webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "02pT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "162F":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("xg5c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("70e574ea", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-34976a1c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vux-loader/src/style-loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./blueSkySt.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-34976a1c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vux-loader/src/style-loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./blueSkySt.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "1H7Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2aRu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ntTm");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("665c1ebc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25e4bbfc\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CMS.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25e4bbfc\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CMS.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3IMD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4PJr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.home[data-v-29fa7a92] {\n  min-height: 100vh;\n  background: #f6faf8;\n}\n\n/* ── Hero ─────────────────────────── */\n.hero[data-v-29fa7a92] {\n  position: relative;\n  overflow: hidden;\n  padding: 52px 20px 0;\n  text-align: center;\n  color: #fff;\n  background:\n    -webkit-radial-gradient(120% 90% at 88% -10%, rgba(7, 193, 96, 0.30), transparent 55%),\n    -webkit-radial-gradient(90% 70% at -12% 108%, rgba(56, 142, 215, 0.26), transparent 60%),\n    -webkit-linear-gradient(282deg, #082739 0%, #0a3d38 55%, #0d4a3c 100%);\n  background:\n    radial-gradient(120% 90% at 88% -10%, rgba(7, 193, 96, 0.30), transparent 55%),\n    radial-gradient(90% 70% at -12% 108%, rgba(56, 142, 215, 0.26), transparent 60%),\n    linear-gradient(168deg, #082739 0%, #0a3d38 55%, #0d4a3c 100%);\n}\n.hero-inner[data-v-29fa7a92] {\n  max-width: 640px;\n  margin: 0 auto;\n}\n.badge[data-v-29fa7a92] {\n  display: -webkit-inline-box;\n  display: inline-flex;\n  display: -webkit-inline-flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n          align-items: center;\n  padding: 8px 18px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.10);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n.badge-ic[data-v-29fa7a92] {\n  width: 28px;\n  height: 28px;\n  margin-right: 10px;\n  border-radius: 9px;\n  background: -webkit-linear-gradient(315deg, #07c160, #069b4e);\n  background: linear-gradient(135deg, #07c160, #069b4e);\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-justify-content: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n  box-shadow: 0 3px 10px -2px rgba(7, 193, 96, 0.7);\n}\n.badge-ic svg[data-v-29fa7a92] {\n  width: 17px;\n  height: 17px;\n}\n.hero h1[data-v-29fa7a92] {\n  margin: 22px 0 12px;\n  font-size: 9vw;\n  line-height: 1.25;\n  font-weight: 900;\n  letter-spacing: 2px;\n}\n.hero h1 em[data-v-29fa7a92] {\n  font-style: normal;\n  color: #8ff0bb;\n  padding: 0 2px;\n}\n.hero-sub[data-v-29fa7a92] {\n  font-size: 15.5px;\n  line-height: 1.8;\n  color: rgba(255, 255, 255, 0.82);\n}\n\n/* 小程序码卡片 */\n.qr-card[data-v-29fa7a92] {\n  display: inline-block;\n  margin-top: 26px;\n  padding: 13px 13px 10px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 24px 50px -18px rgba(0, 22, 10, 0.65), 0 4px 16px rgba(0, 0, 0, 0.18);\n}\n.qr-card img[data-v-29fa7a92] {\n  display: block;\n  width: 150px;\n  height: 150px;\n  border-radius: 12px;\n}\n.qr-cap[data-v-29fa7a92] {\n  margin: 9px 0 2px;\n  font-size: 13.5px;\n  font-weight: 800;\n  color: #06ad56;\n}\n\n/* 公交行驶动画 */\n.road[data-v-29fa7a92] {\n  position: relative;\n  height: 58px;\n  margin-top: 34px;\n  overflow: hidden;\n}\n.road[data-v-29fa7a92]::before {\n  content: \"\";\n  position: absolute;\n  left: -4%;\n  right: -4%;\n  top: 40px;\n  border-top: 2.5px dashed rgba(255, 255, 255, 0.32);\n}\n.bus[data-v-29fa7a92] {\n  position: absolute;\n  top: 4px;\n  left: -72px;\n  width: 58px;\n  -webkit-animation: hm-drive-data-v-29fa7a92 9s linear infinite;\n          animation: hm-drive-data-v-29fa7a92 9s linear infinite;\n}\n\n/* ── 内容区 ───────────────────────── */\n.body[data-v-29fa7a92] {\n  max-width: 1020px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n.sec[data-v-29fa7a92] {\n  padding: 38px 0 10px;\n  text-align: center;\n}\n.sec h2[data-v-29fa7a92] {\n  font-size: 22px;\n  font-weight: 900;\n  color: #101828;\n  letter-spacing: 1px;\n}\n.sec-sub[data-v-29fa7a92] {\n  margin: 8px 0 22px;\n  font-size: 14px;\n  color: #98a2b3;\n}\n.sec-alt[data-v-29fa7a92] {\n  margin: 26px -16px 0;\n  padding: 34px 16px 22px;\n  background: #eef7f1;\n}\n\n/* 功能卡 */\n.feat-list[data-v-29fa7a92] {\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: -12px;\n  margin-left: -12px;\n}\n.feat[data-v-29fa7a92] {\n  -webkit-flex: 1 1 100%;\n  -webkit-box-flex: 1;\n          flex: 1 1 100%;\n  margin: 0 12px 16px;\n  padding: 22px 20px;\n  background: #fff;\n  border: 1px solid #e8f2ec;\n  border-radius: 18px;\n  text-align: left;\n  box-shadow: 0 10px 30px -18px rgba(0, 32, 18, 0.25);\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-align-items: flex-start;\n  -webkit-box-align: start;\n          align-items: flex-start;\n  box-sizing: border-box;\n}\n.feat-ic[data-v-29fa7a92] {\n  -webkit-flex: 0 0 46px;\n  -webkit-box-flex: 0;\n          flex: 0 0 46px;\n  width: 46px;\n  height: 46px;\n  margin-right: 15px;\n  border-radius: 14px;\n  background: #eafaf2;\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-justify-content: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n}\n.feat-ic svg[data-v-29fa7a92] {\n  width: 24px;\n  height: 24px;\n}\n.feat h3[data-v-29fa7a92] {\n  margin: 2px 0 6px;\n  font-size: 16.5px;\n  font-weight: 800;\n  color: #101828;\n}\n.feat p[data-v-29fa7a92] {\n  font-size: 14px;\n  line-height: 1.7;\n  color: #475467;\n}\n\n/* 进入方式 */\n.way-list[data-v-29fa7a92] {\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: -12px;\n  margin-left: -12px;\n}\n.way[data-v-29fa7a92] {\n  -webkit-flex: 1 1 100%;\n  -webkit-box-flex: 1;\n          flex: 1 1 100%;\n  margin: 0 12px 16px;\n  padding: 22px 18px;\n  background: #fff;\n  border-radius: 18px;\n  box-sizing: border-box;\n  box-shadow: 0 10px 30px -18px rgba(0, 32, 18, 0.25);\n}\n.way .num[data-v-29fa7a92] {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: -webkit-linear-gradient(315deg, #07c160, #06ad56);\n  background: linear-gradient(135deg, #07c160, #06ad56);\n  color: #fff;\n  font-weight: 800;\n  font-size: 15px;\n  text-align: center;\n  line-height: 30px;\n  box-shadow: 0 5px 12px -3px rgba(7, 193, 96, 0.55);\n}\n.way h3[data-v-29fa7a92] {\n  margin: 12px 0 6px;\n  font-size: 16.5px;\n  font-weight: 800;\n  color: #101828;\n}\n.way p[data-v-29fa7a92] {\n  font-size: 13.5px;\n  line-height: 1.7;\n  color: #475467;\n}\n\n/* 关于我们 */\n.about-card[data-v-29fa7a92] {\n  padding: 26px 22px;\n  background: #fff;\n  border: 1px solid #e8f2ec;\n  border-radius: 18px;\n  text-align: left;\n  box-shadow: 0 10px 30px -18px rgba(0, 32, 18, 0.25);\n}\n.about-text[data-v-29fa7a92] {\n  font-size: 14.5px;\n  line-height: 1.9;\n  color: #475467;\n}\n\n/* ── 页脚 ─────────────────────────── */\n.foot[data-v-29fa7a92] {\n  padding: 38px 16px 34px;\n  text-align: center;\n}\n.foot-copy[data-v-29fa7a92] {\n  margin: 0 0 6px;\n  font-size: 13px;\n  line-height: 1.7;\n  color: #7d8f88;\n}\n.foot-beian[data-v-29fa7a92] {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.7;\n}\n.foot a[data-v-29fa7a92] {\n  color: #93a5a0;\n  text-decoration: none;\n}\n.foot a[data-v-29fa7a92]:active {\n  opacity: 0.7;\n}\n@-webkit-keyframes hm-drive-data-v-29fa7a92 {\nfrom { left: -72px;\n}\nto   { left: 100%;\n}\n}\n@keyframes hm-drive-data-v-29fa7a92 {\nfrom { left: -72px;\n}\nto   { left: 100%;\n}\n}\n\n/* ── 桌面端适配 ───────────────────── */\n@media (min-width: 480px) {\n.hero h1[data-v-29fa7a92] { font-size: 40px;\n}\n.qr-card img[data-v-29fa7a92] { width: 172px; height: 172px;\n}\n}\n@media (min-width: 720px) {\n.feat[data-v-29fa7a92] { -webkit-flex: 1 1 40%; -webkit-box-flex: 1; flex: 1 1 40%;\n}\n.way[data-v-29fa7a92] { -webkit-flex: 1 1 30%; -webkit-box-flex: 1; flex: 1 1 30%;\n}\n.way .num[data-v-29fa7a92] { display: block; margin: 0 auto;\n}\n.way h3[data-v-29fa7a92] { margin-top: 14px;\n}\n.way p[data-v-29fa7a92] { min-height: 46px;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "4Yh7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.scan-guide[data-v-ddcc4950] {\n  min-height: 100vh;\n  width: 100%;\n  max-width: 520px;\n  margin: 0 auto;\n  padding: 16px 18px 18px;\n  box-sizing: border-box;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  background:\n    -webkit-radial-gradient(120% 90% at 88% -10%, rgba(7, 193, 96, 0.30), transparent 55%),\n    -webkit-radial-gradient(90% 70% at -12% 108%, rgba(56, 142, 215, 0.26), transparent 60%),\n    -webkit-linear-gradient(282deg, #082739 0%, #0a3d38 55%, #0d4a3c 100%);\n  background:\n    radial-gradient(120% 90% at 88% -10%, rgba(7, 193, 96, 0.30), transparent 55%),\n    radial-gradient(90% 70% at -12% 108%, rgba(56, 142, 215, 0.26), transparent 60%),\n    linear-gradient(168deg, #082739 0%, #0a3d38 55%, #0d4a3c 100%);\n}\n\n/* 顶部品牌 */\n.brand[data-v-ddcc4950] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  margin: 2px auto 16px;\n  padding: 8px 18px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.10);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n.brand-ic[data-v-ddcc4950] {\n  width: 28px;\n  height: 28px;\n  margin-right: 10px;\n  border-radius: 9px;\n  background: -webkit-linear-gradient(315deg, #07c160, #069b4e);\n  background: linear-gradient(135deg, #07c160, #069b4e);\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-justify-content: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n  box-shadow: 0 3px 10px -2px rgba(7, 193, 96, 0.7);\n}\n.brand-ic svg[data-v-ddcc4950] {\n  width: 17px;\n  height: 17px;\n}\n\n/* 白色主卡片 */\n.card[data-v-ddcc4950] {\n  width: 100%;\n  background: #fff;\n  border-radius: 26px;\n  padding: 30px 22px 24px;\n  text-align: center;\n  box-shadow: 0 28px 64px -20px rgba(0, 22, 10, 0.60), 0 4px 18px rgba(0, 0, 0, 0.16);\n}\n\n/* 扫描取景框 */\n.frame[data-v-ddcc4950] {\n  position: relative;\n  width: 62vw;\n  height: 62vw;\n  max-width: 230px;\n  max-height: 230px;\n  margin: 4px auto 0;\n}\n.frame[data-v-ddcc4950]::after {\n  content: \"\";\n  position: absolute;\n  top: -14px;\n  right: -14px;\n  bottom: -14px;\n  left: -14px;\n  border-radius: 34px;\n  border: 2.5px solid rgba(7, 193, 96, 0.4);\n  -webkit-animation: sg-pulse-data-v-ddcc4950 2.4s ease-out infinite;\n          animation: sg-pulse-data-v-ddcc4950 2.4s ease-out infinite;\n}\n.frame .c[data-v-ddcc4950] {\n  position: absolute;\n  width: 38px;\n  height: 38px;\n  border: 0 solid #07c160;\n}\n.c1[data-v-ddcc4950] { left: 0;   top: 0;    border-top-width: 5px;    border-left-width: 5px;    border-top-left-radius: 18px;\n}\n.c2[data-v-ddcc4950] { right: 0;  top: 0;    border-top-width: 5px;    border-right-width: 5px;   border-top-right-radius: 18px;\n}\n.c3[data-v-ddcc4950] { left: 0;   bottom: 0; border-bottom-width: 5px; border-left-width: 5px;    border-bottom-left-radius: 18px;\n}\n.c4[data-v-ddcc4950] { right: 0;  bottom: 0; border-bottom-width: 5px; border-right-width: 5px;   border-bottom-right-radius: 18px;\n}\n.frame-inner[data-v-ddcc4950] {\n  position: absolute;\n  top: 11%;\n  right: 11%;\n  bottom: 11%;\n  left: 11%;\n  background: #f1fbf6;\n  border: 1.5px solid #d8f2e4;\n  border-radius: 24px;\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-justify-content: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n}\n.frame-inner svg[data-v-ddcc4950] {\n  width: 60%;\n  -webkit-filter: drop-shadow(0 6px 14px rgba(7, 193, 96, 0.35));\n          filter: drop-shadow(0 6px 14px rgba(7, 193, 96, 0.35));\n}\n.scanline[data-v-ddcc4950] {\n  position: absolute;\n  left: 9%;\n  right: 9%;\n  top: 14%;\n  height: 3.5px;\n  border-radius: 99px;\n  background: -webkit-linear-gradient(left, transparent, #07c160 22%, #07c160 78%, transparent);\n  background: linear-gradient(90deg, transparent, #07c160 22%, #07c160 78%, transparent);\n  box-shadow: 0 0 20px 5px rgba(7, 193, 96, 0.55);\n  -webkit-animation: sg-scan-data-v-ddcc4950 2.2s ease-in-out infinite alternate;\n          animation: sg-scan-data-v-ddcc4950 2.2s ease-in-out infinite alternate;\n}\n.frame-cap[data-v-ddcc4950] {\n  margin-top: 14px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #06ad56;\n  letter-spacing: 4px;\n}\n\n/* 当前软件检测徽章 */\n.app-badge[data-v-ddcc4950] {\n  display: inline-block;\n  margin-top: 16px;\n  padding: 8px 16px;\n  border-radius: 999px;\n  background: -webkit-linear-gradient(315deg, #fff3e2, #ffe9e4);\n  background: linear-gradient(135deg, #fff3e2, #ffe9e4);\n  border: 1px solid #ffd6bd;\n  color: #c2410c;\n  font-size: 13.5px;\n  font-weight: 800;\n}\n.app-badge .dot[data-v-ddcc4950] {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #f76707;\n  margin-right: 7px;\n  -webkit-animation: sg-blink-data-v-ddcc4950 1.1s ease-in-out infinite;\n          animation: sg-blink-data-v-ddcc4950 1.1s ease-in-out infinite;\n}\nh1[data-v-ddcc4950] {\n  margin: 16px 0 10px;\n  font-size: 7.4vw;\n  line-height: 1.3;\n  font-weight: 900;\n  letter-spacing: 1px;\n  color: #101828;\n}\nh1 em[data-v-ddcc4950] {\n  font-style: normal;\n  color: #06ad56;\n  background: -webkit-linear-gradient(transparent 64%, #b7f0d2 64%);\n  background: linear-gradient(transparent 64%, #b7f0d2 64%);\n  padding: 0 3px;\n  border-radius: 4px;\n}\n.sub[data-v-ddcc4950] {\n  color: #475467;\n  font-size: 15px;\n  line-height: 1.75;\n  margin-bottom: 18px;\n}\n.sub strong[data-v-ddcc4950] {\n  color: #e0500f;\n}\n\n/* 三步引导 */\n.steps[data-v-ddcc4950] {\n  list-style: none;\n  padding: 18px 16px;\n  margin: 0;\n  text-align: left;\n  background: #f7fbf9;\n  border: 1px solid #e5f3ec;\n  border-radius: 18px;\n}\n.steps li[data-v-ddcc4950] {\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n          align-items: center;\n  font-size: 15.5px;\n  font-weight: 600;\n  color: #101828;\n}\n.steps li + li[data-v-ddcc4950] {\n  margin-top: 16px;\n}\n.steps .num[data-v-ddcc4950] {\n  -webkit-flex: 0 0 28px;\n  -webkit-box-flex: 0;\n          flex: 0 0 28px;\n  width: 28px;\n  height: 28px;\n  margin-right: 13px;\n  border-radius: 50%;\n  background: -webkit-linear-gradient(315deg, #07c160, #06ad56);\n  background: linear-gradient(135deg, #07c160, #06ad56);\n  color: #fff;\n  font-weight: 800;\n  font-size: 15px;\n  text-align: center;\n  line-height: 28px;\n  box-shadow: 0 5px 12px -3px rgba(7, 193, 96, 0.55);\n}\n.steps b[data-v-ddcc4950] {\n  color: #06ad56;\n}\n.plus[data-v-ddcc4950] {\n  display: inline-block;\n  width: 23px;\n  height: 23px;\n  margin: 0 3px;\n  border-radius: 7px;\n  background: #07c160;\n  color: #fff;\n  font-weight: 800;\n  text-align: center;\n  line-height: 23px;\n  vertical-align: -5px;\n  box-shadow: 0 3px 8px -2px rgba(7, 193, 96, 0.6);\n}\n.banner-tip[data-v-ddcc4950] {\n  margin-top: 18px;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #0b7a4b;\n  background: #eefbf4;\n  border: 1px dashed #9fdebd;\n  border-radius: 12px;\n  padding: 10px 12px;\n}\n\n/* 公交行驶动画 */\n.road[data-v-ddcc4950] {\n  position: relative;\n  width: 100%;\n  height: 58px;\n  margin-top: 16px;\n  overflow: hidden;\n}\n.road[data-v-ddcc4950]::before {\n  content: \"\";\n  position: absolute;\n  left: -4%;\n  right: -4%;\n  top: 40px;\n  border-top: 2.5px dashed rgba(255, 255, 255, 0.32);\n}\n.bus[data-v-ddcc4950] {\n  position: absolute;\n  top: 4px;\n  left: -72px;\n  width: 58px;\n  -webkit-animation: sg-drive-data-v-ddcc4950 9s linear infinite;\n          animation: sg-drive-data-v-ddcc4950 9s linear infinite;\n}\n.foot[data-v-ddcc4950] {\n  margin-top: 8px;\n  padding-bottom: 2px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 12.5px;\n  letter-spacing: 0.5px;\n}\n@-webkit-keyframes sg-scan-data-v-ddcc4950 {\nfrom { top: 14%;\n}\nto   { top: 84%;\n}\n}\n@keyframes sg-scan-data-v-ddcc4950 {\nfrom { top: 14%;\n}\nto   { top: 84%;\n}\n}\n@-webkit-keyframes sg-pulse-data-v-ddcc4950 {\n0%   { -webkit-transform: scale(0.94); transform: scale(0.94); opacity: 0.9;\n}\n70%  { -webkit-transform: scale(1.08); transform: scale(1.08); opacity: 0;\n}\n100% { -webkit-transform: scale(1.08); transform: scale(1.08); opacity: 0;\n}\n}\n@keyframes sg-pulse-data-v-ddcc4950 {\n0%   { -webkit-transform: scale(0.94); transform: scale(0.94); opacity: 0.9;\n}\n70%  { -webkit-transform: scale(1.08); transform: scale(1.08); opacity: 0;\n}\n100% { -webkit-transform: scale(1.08); transform: scale(1.08); opacity: 0;\n}\n}\n@-webkit-keyframes sg-blink-data-v-ddcc4950 {\n0%, 100% { opacity: 1;\n}\n50%      { opacity: 0.25;\n}\n}\n@keyframes sg-blink-data-v-ddcc4950 {\n0%, 100% { opacity: 1;\n}\n50%      { opacity: 0.25;\n}\n}\n@-webkit-keyframes sg-drive-data-v-ddcc4950 {\nfrom { left: -72px;\n}\nto   { left: calc(100% + 12px);\n}\n}\n@keyframes sg-drive-data-v-ddcc4950 {\nfrom { left: -72px;\n}\nto   { left: calc(100% + 12px);\n}\n}\n@media (min-width: 480px) {\nh1[data-v-ddcc4950] { font-size: 32px;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "6/lx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wl_xxsz.acc8b83.png";

/***/ }),

/***/ "6NVF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coupons-card.2dc8e37.png";

/***/ }),

/***/ "6Rx/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAsCAYAAAAXb/p7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0iN0U5NDVCOTUzQzE0NDM3RDVFQUIwM0JENTg1OUJCREYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTE4NkM1QTQxRDhCMTFFQUFEMkNFNUE3MUI3OThCQTYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTE4NkM1QTMxRDhCMTFFQUFEMkNFNUE3MUI3OThCQTYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ODJlMjM5MDEtOWMzZS1hMTQ2LWI0NDItOGNkZjhhNzA1ODY3IiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6MDYwOWUzZWYtN2RhNi02MTRmLTk5NDYtNjI3OGExMTgzMjQwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+cKfowgAAAvVJREFUeNrsmVuITVEYgOeMUSOj5oFR5K4MJaVmlFGmUYzIbZJLyotDmVwmL5KMa5pyGw25PSiKRAZFMeKBSENImJE6DxPHA7krlzm+Vf/UTnP2/tfe6zjzcFZ9rbP32pdv1v73Wv9eE0ulUnk9ueTn9fCSE4xaCoIOGLQ3UUi1HCphApigfQY34QR0RhF4s2G4b3vM7yVBrprqKAxNc0gbVJn7ZEow30duDtU1HzlTxsDV/x6DyA2guqS8hnnsswKO6e/6JdlpeZ2ZAe2D4T6sgsJIgvSeeaQrLQWrA9qfwFM4Au2wJkoPzgjxJEbBwIBjzB/dCkPgIFwIKzg6ZLiUWPb0ArgVRnB8SMG+Pm3rYBO8h3me/ZWE1DFbwbBvnN+AbeJvF1yR0aHR0xZHcpyNYEFIwQ8+beZRLoTZcBvWw0tP+0kbwW8h5N5Bopv9/Ty/zwtToV5ku0qZjWAihOB++J0mLps9cbcUPsNWeA2bZf9XG8F2Szlz/L40bUlogYtQCr+gRtoWS1yafUU2gkml2GPJZsrlJulKE9yBy7LdIrPKWtleZvsWP1IK1pGJxKk/KadCM5sUe8bA3ZLNnKParhbkhIdUrxQ3bbAIAxNjizw9/VaGnK571tsmC6cVNy1n/JpiOU5ajxDpBK8rz2/MyjcJXW6C+IXi/IkwPVsfTU3Ka5zKiiC9eJjquzKLOeTZ7g2TYRqMzfRn5zbldVbDJMkLzQhwV8a75xIqtZkS3AM/lNe6J7PKsH/2l3oG6xFOBXnMndI7mhILuF6FpF0VTlcWkDSp0ANHMV8kPVnmeumjJmC+tS1mnO3lTJBe7KCa61CwWPsCqhePkDSrDAccSsadr24hWScJqItS0s0bH01QJOdT3XAk2ce5oEia+fdsRLmPmrQu9AImkkuotkQQNBn1n4wJiuQOKvPIOyxPPa5NMlwsATfLHNwgKweaTFy9OOVqjfonbISRsALOyLfyFyEpvVYlx6lLLPd/kpxglstfAQYASzCwIHL2g6MAAAAASUVORK5CYII="

/***/ }),

/***/ "9YoK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "9usb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("kZU+");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0781dbee", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-315574b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ncljlPromote.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-315574b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ncljlPromote.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "BWPK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/red-envelope-bottom-ljl.056453e.png";

/***/ }),

/***/ "E+dh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/03_11.43526fc.png";

/***/ }),

/***/ "HxK8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("iwAQ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("589e804d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-69a2f5ec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./browser.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-69a2f5ec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./browser.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Jnhj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.index-wrap[data-v-3c3b0686] {\n  position: relative;\n  background-color: #f4f4f4;\n  font-family: PingFangSC-Medium;\n}\n\n/* 滑块导航 */\n.tabWrap[data-v-3c3b0686] {\n  margin-top: 0;\n}\n.tabWrap .scrollCon .scroll-view-x[data-v-3c3b0686] {\n  width: 100%;\n  height: 185px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  overflow-y: hidden;\n  overflow-x: scroll;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n}\n.scrollpadding0[data-v-3c3b0686] {\n  padding-left: 10px;\n}\n.scrollpadding1[data-v-3c3b0686],\n.scrollpadding2[data-v-3c3b0686] {\n  padding-left: 5px;\n}\n.scrollpadding3[data-v-3c3b0686] {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.selected[data-v-3c3b0686],\n.default[data-v-3c3b0686] {\n  background-color: #fff;\n}\n.default[data-v-3c3b0686] {\n  width: 143px;\n  height: 144px;\n  box-sizing: border-box;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  padding-top: 15px;\n  padding-left: 14px;\n  border-radius: 14px;\n}\n.default label[data-v-3c3b0686] {\n  display: block;\n}\n.default .itemtitle[data-v-3c3b0686] {\n  font-size: 15px;\n  font-weight: 600;\n  color: #999;\n}\n.default .itemsummary[data-v-3c3b0686] {\n  height: 30px;\n  font-weight: 500;\n  font-size: 11px;\n  color: #666;\n  line-height: 15px;\n  margin-top: 15px;\n}\n.selected[data-v-3c3b0686] {\n  width: 150px;\n  height: 155px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  box-sizing: border-box;\n  padding-top: 18px;\n  padding-left: 17px;\n  border-radius: 16px;\n  box-shadow: 0 6px 15px -9px;\n}\n.selected label[data-v-3c3b0686] {\n  display: block;\n}\n.itemtitle[data-v-3c3b0686] {\n  font-size: 17px;\n  font-weight: 600;\n  color: #917ddc;\n  line-height: 28px;\n}\n.itemsummary[data-v-3c3b0686] {\n  height: 34px;\n  line-height: 17px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #666;\n  margin-top: 15px;\n}\n.selectImg[data-v-3c3b0686] {\n  width: 40px;\n  height: 33px;\n  margin-top: 15px;\n}\n.selectImg1[data-v-3c3b0686] {\n  width: 35px;\n  height: 33px;\n  margin-top: 10px;\n}\n.biger[data-v-3c3b0686] {\n  -webkit-transform: scale(1.1);\n}\n.small[data-v-3c3b0686] {\n  -webkit-transform: scale(0.9);\n}\n.show[data-v-3c3b0686] {\n  display: block;\n}\n.hidden[data-v-3c3b0686] {\n  display: none;\n}\n\n/* 首页切换面板 */\n.goukaboard[data-v-3c3b0686],\n.icCardBoard[data-v-3c3b0686],\n.kamengboard[data-v-3c3b0686],\n.memberboard[data-v-3c3b0686] {\n  width: 90%;\n  margin: 0 auto;\n  position: relative;\n}\n.mb[data-v-3c3b0686] {\n  height: 16px;\n}\n\n/* 购卡板块 */\n.goukaboard .goukason[data-v-3c3b0686] {\n  height: 90px;\n  box-shadow: 0 6px 21px -9px rgba(44, 71, 148, 1);\n  border-radius: 16px;\n  margin: 0 auto 10px;\n  box-sizing: border-box;\n  padding: 16px 0 0 16px;\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n}\n.goukaboard .goukason label[data-v-3c3b0686] {\n  display: block;\n  color: #fff;\n  z-index: 9;\n}\n.goukaboard .goukason img[data-v-3c3b0686] {\n  height: 100%;\n  border-radius: 16px;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.goukaboard .goukason3 img[data-v-3c3b0686] {\n  width: 135px;\n}\n.goukaboard .goukason2 img[data-v-3c3b0686] {\n  width: 108px;\n}\n.goukaboard .goukason1 img[data-v-3c3b0686] {\n  width: 105px;\n}\n.goukaboard .goukasonWechat img[data-v-3c3b0686] {\n  width: 135px;\n}\n.goukaboard .goukason4 img[data-v-3c3b0686] {\n  width: 132px;\n}\n.goukaboard .goukason5 img[data-v-3c3b0686] {\n  width: 132px;\n}\n.goukaboard .goukason .title[data-v-3c3b0686] {\n  font-size: 16px;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n.goukaboard .goukason .description[data-v-3c3b0686] {\n  font-size: 14px;\n}\n.goukaboard .goukason1[data-v-3c3b0686] {\n  background: -webkit-linear-gradient(left, #2956ec, #4d75ed);\n  background: linear-gradient(to right, #2956ec, #4d75ed);\n}\n.goukaboard .goukason2[data-v-3c3b0686] {\n  background: -webkit-linear-gradient(left, #ff9514, #ffbb6c);\n  background: linear-gradient(to right, #ff9514, #ffbb6c);\n}\n.goukaboard .goukason3[data-v-3c3b0686] {\n  background: -webkit-linear-gradient(left, #20b882, #41d69c);\n  background: linear-gradient(to right, #20b882, #41d69c);\n}\n.goukaboard .goukasonWechat[data-v-3c3b0686] {\n  background: -webkit-linear-gradient(left, #09bb07, #09bb64);\n  background: linear-gradient(to right, #09bb07, #09bb64);\n}\n.goukaboard .goukason4[data-v-3c3b0686] {\n  background: -webkit-linear-gradient(left, #f94a4e, #fe715a);\n  background: linear-gradient(to right, #f94a4e, #fe715a);\n}\n.goukaboard .goukason5[data-v-3c3b0686] {\n  background: -webkit-linear-gradient(left, #a945f6, #9966ff);\n  background: linear-gradient(to right, #a945f6, #9966ff);\n}\n\n/* 特卖板块 */\n.icCardBoard[data-v-3c3b0686] {\n  background: rgba(255, 255, 255, 1);\n  box-shadow: 0 6px 21px -9px rgba(44, 71, 148, 1);\n  border-radius: 16px;\n}\n.icCardBoard .icCardTab[data-v-3c3b0686] {\n  width: 100%;\n  height: 57px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  padding: 18px 0 0 0;\n}\n.icCardBoard .icCardTab .title[data-v-3c3b0686] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n          flex: 1;\n}\n.icCardBoard .icCardTab .line[data-v-3c3b0686] {\n  width: 0px;\n  height: 13px;\n  border: 1px solid #a5a5a5;\n  margin-top: 8px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.icCardBoard .icCardTab view[data-v-3c3b0686] {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n          flex: 1;\n  text-align: center;\n}\n.icCardBoard .icCardTab .temaidefault .title[data-v-3c3b0686] {\n  color: #666666;\n  font-size: 16px;\n  letter-spacing: 1px;\n  font-weight: 400;\n}\n.icCardBoard .icCardTab .temaiselected .title[data-v-3c3b0686] {\n  color: #7661d1;\n  font-size: 16px;\n  letter-spacing: 1px;\n  border-bottom: #7661d1 solid 3px;\n  padding-bottom: 8px;\n}\n.icCardBoard .busServerBorad[data-v-3c3b0686] {\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n.icCardBoard .busServerBorad .busServerItem[data-v-3c3b0686] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  padding: 10px;\n}\n.icCardBoard .busServerBorad .busServerItem .name[data-v-3c3b0686] {\n  font-size: 16px;\n  font-weight: 400;\n  color: #7661d1;\n}\n.icCardBoard .busServerBorad .busServerItem .address[data-v-3c3b0686] {\n  font-size: 14px;\n  font-weight: 400;\n  margin-top: 6px;\n  color: #666666;\n}\n.icCardBoard .moretelnum[data-v-3c3b0686] {\n  text-align: center;\n  font-size: 14px;\n  color: #7661d1;\n  text-decoration: underline;\n  padding: 10px 0 28px 0;\n  letter-spacing: 1px;\n}\n.icCardBoard .lovetelboard .lovetellists[data-v-3c3b0686] {\n  height: 52px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  padding-left: 21px;\n  margin: 9px 0;\n}\n.icCardBoard .lovetelboard .lovetellists .lovetll[data-v-3c3b0686] {\n  -webkit-box-flex: 2;\n  -webkit-flex: 2;\n          flex: 2;\n  height: 100%;\n}\n.icCardBoard .lovetelboard .lovetellists .lovetll view[data-v-3c3b0686] {\n  display: block;\n  font-size: 16px;\n  color: #666;\n}\n.icCardBoard .lovetelboard .lovetellists .lovetll .lovenum[data-v-3c3b0686] {\n  color: #ff8c8c;\n}\n.icCardBoard .lovetelboard .lovetellists .lovetlm[data-v-3c3b0686] {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n          flex: 1;\n}\n.icCardBoard .lovetelboard .lovetellists .lovetlm text[data-v-3c3b0686] {\n  line-height: 46px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #999;\n  padding-left: 10px;\n}\n.icCardBoard .lovetelboard .lovetellists .lovetlr[data-v-3c3b0686] {\n  -webkit-box-flex: 2;\n  -webkit-flex: 2;\n          flex: 2;\n  text-align: right;\n  line-height: 46px;\n}\n.icCardBoard .lovetelboard .lovetellists .lovetlr .op[data-v-3c3b0686] {\n  font-size: 12px;\n  color: #999;\n  text-decoration: line-through;\n  margin-right: 5px;\n}\n.icCardBoard .lovetelboard .lovetellists .lovetlr .np[data-v-3c3b0686] {\n  font-size: 14px;\n  color: #7661d1;\n  padding-right: 20px;\n}\n.icCardBoard .wholelove[data-v-3c3b0686] {\n  padding-bottom: 22px;\n}\n.numbertype[data-v-3c3b0686] {\n  width: 13px;\n  height: 13px;\n}\n\n/* .telScore {\n    flex: 2;\n    text-align: center;\n    align-items: center;\n    font-size: 22rpx;\n    color: #633D1B;\n    background: #ffdc66;\n    border-radius: 12rpx;\n    line-height: 38rpx;\n  } */\n\n/* 卡盟板块 */\n.kamengboard[data-v-3c3b0686] {\n  background: #fff;\n  box-shadow: 0 6px 21px -9px rgba(44, 71, 148, 1);\n  border-radius: 16px;\n  overflow: hidden;\n}\n.kamengboard text[data-v-3c3b0686] {\n  color: #666;\n}\n.kameng-head[data-v-3c3b0686],\n.kameng1[data-v-3c3b0686],\n.kameng-title[data-v-3c3b0686] {\n  text-align: center;\n}\n.kameng-title[data-v-3c3b0686] {\n  margin-bottom: 15px;\n}\n.kameng-head text[data-v-3c3b0686] {\n  height: 44px;\n  background: #7661d1;\n  color: #fff;\n  line-height: 44px;\n}\n.kameng-head image[data-v-3c3b0686] {\n  width: 178px;\n  height: 37px;\n  margin: 40px auto 10px;\n}\n.kameng1 .kmtitle[data-v-3c3b0686] {\n  margin: 25px auto;\n}\n.kameng1 text[data-v-3c3b0686] {\n  font-size: 12px;\n  padding: 3px;\n}\n.kameng1 image[data-v-3c3b0686] {\n  width: 258px;\n  height: 83px;\n  margin: 40px auto 30px;\n}\n.kameng2 image[data-v-3c3b0686] {\n  width: 305px;\n  height: 190px;\n  margin: 0 auto 15px;\n}\n.km2-point[data-v-3c3b0686] {\n  padding: 0 25px;\n}\n.km2-point text[data-v-3c3b0686] {\n  font-size: 9px;\n  color: #7661d1;\n  padding: 3px 0;\n}\n.km2-point .row view[data-v-3c3b0686] {\n  width: 75px;\n  margin-right: 48px;\n  margin: 0 48px 25px 0;\n}\n.km2-point .row view .greytext[data-v-3c3b0686] {\n  color: #9a9a9a;\n}\n.km2-point .kmh3[data-v-3c3b0686] {\n  color: #333;\n  padding-bottom: 3px;\n}\n.km2-point .line1[data-v-3c3b0686] {\n  width: 70px;\n  height: 2px;\n  color: #333;\n  background: #7661d1;\n  border-radius: 4px;\n  margin-bottom: 3px;\n}\n.km-kk[data-v-3c3b0686] {\n  -webkit-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n.km-kk view[data-v-3c3b0686] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  width: 50%;\n  height: 216px;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n}\n.kkimg[data-v-3c3b0686] {\n  background: #eeeeee;\n}\n.kkimg image[data-v-3c3b0686] {\n  width: 114px;\n  height: 202px;\n}\n.km-kk text[data-v-3c3b0686] {\n  color: #333;\n}\n.km-kk .kmh3[data-v-3c3b0686] {\n  color: #666;\n}\n.tc-table[data-v-3c3b0686] {\n  position: relative;\n}\n.tc-name[data-v-3c3b0686] {\n  width: 100%;\n  text-align: center;\n  position: absolute;\n  top: 3px;\n}\n.tc-table text[data-v-3c3b0686] {\n  display: inline-block;\n}\n.tc-table .line2[data-v-3c3b0686] {\n  width: 100%;\n  height: 2px;\n  background: #a4a4a4;\n}\n.tc-name .kmh2[data-v-3c3b0686] {\n  padding: 0 10px;\n  background: #fff;\n  z-index: 1000;\n}\n.zifei[data-v-3c3b0686] {\n  margin: 15px 0;\n}\n.zifei view[data-v-3c3b0686] {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n          flex: 1;\n  text-align: center;\n}\n.zifei .kmh3[data-v-3c3b0686] {\n  width: 100%;\n}\n.zifei .line3[data-v-3c3b0686] {\n  border-right: 2px solid #7661d1;\n}\n.zftable[data-v-3c3b0686] {\n  padding: 10px 10px 20px;\n}\n.zftable view text[data-v-3c3b0686] {\n  width: 100%;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n          flex: 1;\n  text-align: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n}\n.zftable view .flex2[data-v-3c3b0686] {\n  -webkit-box-flex: 2;\n  -webkit-flex: 2;\n          flex: 2;\n}\n.zftable view .flex1[data-v-3c3b0686] {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n          flex: 1;\n}\n.zftable view .flex3[data-v-3c3b0686] {\n  -webkit-box-flex: 3;\n  -webkit-flex: 3;\n          flex: 3;\n}\n.zftable view .flex4[data-v-3c3b0686] {\n  -webkit-box-flex: 4;\n  -webkit-flex: 4;\n          flex: 4;\n}\n.zftable .th text[data-v-3c3b0686] {\n  font-weight: bold;\n}\n.zftable .th text[data-v-3c3b0686],\n.zftable .td text[data-v-3c3b0686] {\n  padding: 10px 5px;\n  background: #eee;\n  border: 2px solid #fff;\n  font-size: 10px;\n  box-sizing: border-box;\n}\n.zftable .wxskth[data-v-3c3b0686] {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n}\n.zftable .wxskth text[data-v-3c3b0686] {\n  height: 80px;\n}\n.kameng5 .row image[data-v-3c3b0686] {\n  width: 156px;\n  height: 278px;\n}\n.kameng5 .row view[data-v-3c3b0686] {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n          flex: 1;\n  padding: 0 10px;\n  box-sizing: border-box;\n}\n.kameng5 .row view text[data-v-3c3b0686] {\n  font-size: 12px;\n  color: #666;\n  line-height: 27px;\n}\n.kameng5 .product[data-v-3c3b0686] {\n  background: #eee;\n  text-align: center;\n  margin-top: 40px;\n  padding-bottom: 35px;\n}\n.kameng5 .product text[data-v-3c3b0686] {\n  padding: 25px;\n}\n.kameng5 .product image[data-v-3c3b0686] {\n  width: 310px;\n  height: 270px;\n  margin: 0 auto;\n}\n.kameng-foot[data-v-3c3b0686] {\n  width: 100%;\n  height: 48px;\n  font-size: 18px;\n  background: #7661d1;\n  text-align: center;\n  line-height: 48px;\n  color: #fff;\n}\n.kamengboard .purple[data-v-3c3b0686] {\n  color: #7660d5;\n}\n.kamengboard .kmtitle[data-v-3c3b0686] {\n  font-size: 35px;\n  font-weight: bold;\n  margin: 5px auto;\n  color: #313131;\n}\n.kamengboard .kmh2[data-v-3c3b0686] {\n  font-size: 18px;\n}\n.kamengboard .line0[data-v-3c3b0686] {\n  display: block;\n  width: 25px;\n  height: 3px;\n  background: #acacac;\n  border-radius: 6px;\n  margin: 10px auto;\n}\n.kamengboard .kmh4[data-v-3c3b0686] {\n  font-size: 10px;\n  color: #acacac;\n}\n.kamengboard .kmh3[data-v-3c3b0686] {\n  font-size: 14px;\n}\n\n/* 会员中心板块 */\n.memberboard .weallists .row[data-v-3c3b0686] {\n  width: 100%;\n  height: 80px;\n  background-color: #fff;\n  box-shadow: 0 6px 21px -9px #2c4794;\n  border-radius: 11px;\n  margin-bottom: 10px;\n\n  font-size: 18px;\n  box-sizing: border-box;\n}\n.memberboard .weallists .column[data-v-3c3b0686] {\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n}\n.memberboard .weallists .memdetails text[data-v-3c3b0686] {\n  color: #4b4b4b;\n  font-size: 13px;\n  line-height: 20px;\n}\n.memtitle[data-v-3c3b0686] {\n  font-size: 15px;\n  font-weight: bold;\n}\n.memberboard .weallists .column .memprice[data-v-3c3b0686] {\n  color: #917ddc;\n}\n.memimg image[data-v-3c3b0686] {\n  width: 60px;\n  height: 60px;\n}\n.memimg[data-v-3c3b0686],\n.membuy[data-v-3c3b0686] {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n          flex: 1;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n}\n.memdetails[data-v-3c3b0686] {\n  -webkit-box-flex: 2;\n  -webkit-flex: 2;\n          flex: 2;\n}\n.membuy text[data-v-3c3b0686] {\n  font-size: 14px;\n  background: #917ddc;\n  color: #ffffff;\n  padding: 5px 20px;\n  border-radius: 20px;\n}\n.memberboard .moreweal[data-v-3c3b0686] {\n  text-align: center;\n  padding: 15px 0;\n}\n.memberboard .moreweal text[data-v-3c3b0686] {\n  font-size: 14px;\n  color: #cccccc;\n}\n.goTop[data-v-3c3b0686] {\n  height: 40px;\n  width: 40px;\n  position: fixed;\n  bottom: 25px;\n  right: 15px;\n}\n\n/* 遮罩层 */\n.maskLayer[data-v-3c3b0686] {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: #000;\n  opacity: 0.2;\n  overflow: hidden;\n  z-index: 1000;\n  color: #fff;\n}\n\n/*抽屉弹框 */\n.bottom_box[data-v-3c3b0686] {\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  overflow: hidden;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 2000;\n  background: #fff;\n  box-sizing: border-box;\n  border-radius: 16px 16px 0 0;\n}\n.bottom_box_con[data-v-3c3b0686] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  padding: 5px 5px;\n  margin-bottom: 60px;\n}\n.closevip image[data-v-3c3b0686] {\n  width: 25px;\n  height: 25px;\n  padding: 10px 10px 15px;\n  float: right;\n}\n.wenxintips[data-v-3c3b0686] {\n  text-align: center;\n  clear: both;\n  color: #4b4b4b;\n  font-size: 16px;\n  margin: 0 0 40px;\n}\n.wenxintips[data-v-3c3b0686],\n.vipinput input[data-v-3c3b0686] {\n  display: block;\n  font-size: 16px;\n}\n.vipinput[data-v-3c3b0686] {\n  width: 76%;\n  margin: 5px auto 40px;\n}\n.buyvip[data-v-3c3b0686] {\n  width: 100%;\n  height: 48px;\n  background: #917ddc;\n  text-align: center;\n  line-height: 48px;\n}\n.buyvip text[data-v-3c3b0686] {\n  font-size: 16px;\n  color: #fff;\n}\n.toast[data-v-3c3b0686] {\n  position: fixed;\n  z-index: 2000;\n  left: 50%;\n  top: 45%;\n  -webkit-transition: all 0.5s;\n  transition: all 0.5s;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n  transform: translateX(-50%) translateY(-50%);\n  text-align: center;\n  border-radius: 5px;\n  color: #fff;\n  background: rgba(17, 17, 17, 0.7);\n  height: 45px;\n  line-height: 45px;\n  padding: 0 15px;\n  max-width: 150px;\n}\n", ""]);

// exports


/***/ }),

/***/ "L7S0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/red-envelope-bottom.1c95247.png";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/HelloWorld.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HelloWorld = ({
  name: 'helloWorld'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/HelloWorld.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var page_HelloWorld = ({
  name: 'helloWorld'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29fa7a92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/HelloWorld.vue
var HelloWorld_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c("header", { staticClass: "hero" }, [
      _c("div", { staticClass: "hero-inner" }, [
        _c("div", { staticClass: "badge" }, [
          _c("span", { staticClass: "badge-ic" }, [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 64 34",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("rect", {
                  attrs: {
                    x: "2",
                    y: "2",
                    width: "56",
                    height: "24",
                    rx: "7",
                    fill: "#fff"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "2",
                    y: "20",
                    width: "56",
                    height: "3",
                    fill: "#07c160"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "7",
                    y: "7",
                    width: "9",
                    height: "9",
                    rx: "2",
                    fill: "#0b3d33"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "20",
                    y: "7",
                    width: "9",
                    height: "9",
                    rx: "2",
                    fill: "#0b3d33"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "33",
                    y: "7",
                    width: "9",
                    height: "9",
                    rx: "2",
                    fill: "#0b3d33"
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "46",
                    y: "7",
                    width: "7",
                    height: "16",
                    rx: "2",
                    fill: "#0b3d33"
                  }
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
                }),
                _c("circle", {
                  attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
                }),
                _c("circle", {
                  attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("果城行丨公共出行服务查询")])
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "road" }, [
        _c(
          "svg",
          {
            staticClass: "bus",
            attrs: {
              viewBox: "0 0 64 34",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("rect", {
              attrs: {
                x: "2",
                y: "2",
                width: "56",
                height: "24",
                rx: "7",
                fill: "#ffffff"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "2",
                y: "20",
                width: "56",
                height: "3",
                fill: "#07c160"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "7",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "20",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "33",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "46",
                y: "7",
                width: "7",
                height: "16",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
            })
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "body" }, [
      _c("section", { staticClass: "sec" }, [
        _c("h2", [_vm._v("核心功能")]),
        _vm._v(" "),
        _c("p", { staticClass: "sec-sub" }, [
          _vm._v("为南充市民出行打造的实时公交服务")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "feat-list" }, [
          _c("div", { staticClass: "feat" }, [
            _c("span", { staticClass: "feat-ic" }, [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("circle", {
                    attrs: {
                      cx: "12",
                      cy: "12",
                      r: "9",
                      stroke: "#06ad56",
                      "stroke-width": "2"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M12 7.5v4.5l3.2 2",
                      stroke: "#06ad56",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(3)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "feat" }, [
            _c("span", { staticClass: "feat-ic" }, [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M6 18c6.5 0 5.5-12 12-12",
                      stroke: "#06ad56",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: { cx: "6", cy: "18", r: "2.2", fill: "#06ad56" }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: { cx: "18", cy: "6", r: "2.2", fill: "#06ad56" }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(4)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "feat" }, [
            _c("span", { staticClass: "feat-ic" }, [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M12 3.6l2.5 5.1 5.6.8-4 4 .9 5.6-5-2.6-5 2.6.9-5.6-4-4 5.6-.8z",
                      stroke: "#06ad56",
                      "stroke-width": "2",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(5)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "feat" }, [
            _c("span", { staticClass: "feat-ic" }, [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M12 21s-6.2-5-6.2-10.2a6.2 6.2 0 1 1 12.4 0C18.2 16 12 21 12 21z",
                      stroke: "#06ad56",
                      "stroke-width": "2",
                      "stroke-linejoin": "round"
                    }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: {
                      cx: "12",
                      cy: "10.6",
                      r: "2.2",
                      stroke: "#06ad56",
                      "stroke-width": "2"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(6)
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _vm._m(8)
    ]),
    _vm._v(" "),
    _vm._m(9)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _vm._v("南充公交"),
      _c("em", [_vm._v("实时")]),
      _vm._v("掌握")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hero-sub" }, [
      _vm._v("\n        到站查询 · 换乘规划 · 站点周边"),
      _c("br"),
      _vm._v("\n        无需下载APP，微信扫码即用\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "qr-card" }, [
      _c("img", {
        attrs: {
          src: __webpack_require__("ijc4"),
          alt: "小程序码"
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "qr-cap" }, [_vm._v("微信扫一扫 · 进入小程序")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("实时到站查询")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("车辆位置实时可见，还有几站、多久到站一目了然，出行不再干等。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("换乘路线规划")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("输入起点终点，一键规划公交换乘方案，步行、候车时间全知道。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("通勤常用收藏")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("常用线路与站点收藏在首页，通勤卡片一屏即见，查车更快。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("站点周边线路")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("定位或搜索任意站点，周边经过线路全部掌握，换乘不迷路。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "sec sec-alt" }, [
      _c("h2", [_vm._v("三种方式进入小程序")]),
      _vm._v(" "),
      _c("p", { staticClass: "sec-sub" }, [
        _vm._v("无需下载 · 即扫即用 · 免费便民")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "way-list" }, [
        _c("div", { staticClass: "way" }, [
          _c("span", { staticClass: "num" }, [_vm._v("1")]),
          _vm._v(" "),
          _c("h3", [_vm._v("站台扫码")]),
          _vm._v(" "),
          _c("p", [_vm._v("用微信「扫一扫」扫描公交站台上的二维码")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "way" }, [
          _c("span", { staticClass: "num" }, [_vm._v("2")]),
          _vm._v(" "),
          _c("h3", [_vm._v("微信搜索")]),
          _vm._v(" "),
          _c("p", [_vm._v("微信内搜索小程序「果城行丨公共出行服务查询」")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "way" }, [
          _c("span", { staticClass: "num" }, [_vm._v("3")]),
          _vm._v(" "),
          _c("h3", [_vm._v("本页扫码")]),
          _vm._v(" "),
          _c("p", [_vm._v("微信扫一扫上方小程序码，或截图后长按识别")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "sec" }, [
      _c("h2", [_vm._v("关于我们")]),
      _vm._v(" "),
      _c("p", { staticClass: "sec-sub" }, [_vm._v("立足南充 · 服务本地出行")]),
      _vm._v(" "),
      _c("div", { staticClass: "about-card" }, [
        _c("p", { staticClass: "about-text" }, [
          _vm._v(
            "\n          南充七安网络科技有限公司立足南充，专注本地智慧出行服务，\n          自主研发运营「果城行丨公共出行服务查询」微信小程序，\n          为市民提供公交实时到站查询、换乘规划、站点查询等便民服务。\n        "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "foot" }, [
      _c("p", { staticClass: "foot-copy" }, [
        _vm._v("Copyright © 2019-2026 南充七安网络科技有限公司")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "foot-beian" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://beian.miit.gov.cn/",
              target: "_blank",
              rel: "noopener nofollow"
            }
          },
          [_vm._v("蜀ICP备2024078067号-12")]
        )
      ])
    ])
  }
]
HelloWorld_render._withStripped = true
var esExports = { render: HelloWorld_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_page_HelloWorld = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29fa7a92", esExports)
  }
}
// CONCATENATED MODULE: ./src/page/HelloWorld.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("bELE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29fa7a92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  page_HelloWorld,
  selectortype_template_index_0_src_page_HelloWorld,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/HelloWorld.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-29fa7a92", Component.options)
  } else {
    hotAPI.reload("data-v-29fa7a92", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var src_page_HelloWorld = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/fetch/api.js



// import Config from "../../config/index";

var service = axios_default.a.create({
  // baseURL: "https://api.nanchongcity.com", // api的base_url
  timeout: 60000
});

//添加请求拦截器
service.interceptors.request.use(function (config) {
  if (config.method === "post") {
    config.data = lib_default.a.stringify(config.data);
  }
  return config;
}, function (error) {
  return promise_default.a.reject(error);
});

//添加响应拦截器
service.interceptors.response.use(function (res) {
  console.log(res);
  return res;
}, function (error) {
  console.log(error);
  return promise_default.a.reject(error);
});

function post(url, params) {
  return new promise_default.a(function (resolve, reject) {
    service.post(url, params).then(function (response) {
      if (response.status === 200) {
        resolve(response.data);
      } else {
        reject("网络请求出错...");
      }
    }).catch(function (error) {
      reject(error);
    });
  });
}

function get(url, params) {
  return new promise_default.a(function (resolve, reject) {
    service.get(url, params).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/* harmony default export */ var api = ({
  getOffcialSite: function getOffcialSite() {
    return get("/api/offcialsite");
  },
  getProductList: function getProductList() {
    return get("/api/offcialsite/product");
  },
  getSolutionList: function getSolutionList() {
    return get("/api/offcialsite/solution");
  },
  getCaseList: function getCaseList() {
    return get("/api/offcialsite/case");
  },
  getNewsList: function getNewsList() {
    return get("/api/offcialsite/news");
  },
  getArticle: function getArticle(id, type) {
    return get("/api/offcialsite/article?id=" + id + "&type=" + type);
  },
  saveContact: function saveContact(params) {
    return post("/api/offcialsite/contact", params);
  },
  setAdRecord: function setAdRecord(params) {
    return post("/api/ad/record", params);
  },
  getCmsContent: function getCmsContent(id) {
    return get("/api/sp/notice/getById?id=" + id);
  },

  // H5访问统计上报（gcx-realtime-bus /appApi 匿名接口；绝对地址跨域，后端已开CORS）
  h5VisitReport: function h5VisitReport(params) {
    return post("https://rt-api.steadan.com/appApi/statistics/h5Visit", params);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/CMS.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var CMS = ({
  name: "CMS",
  data: function data() {
    return {
      loading: true,
      articleInfo: undefined
    };
  },
  mounted: function mounted() {
    this.init();
  },

  methods: {
    init: function init() {
      var _this = this;

      this.id = this.$route.query.id;
      if (this.id) {
        var that = this;
        this.loading = true;
        api.getArticle(this.id).then(function (res) {
          if (res.code === 20000 && res.data) {
            _this.articleInfo = res.data;
          }
          _this.loading = false;
        }).catch(function () {
          _this.loading = false;
        });
      }
    },
    callPhone: function callPhone() {
      window.location.href = "tel://" + this.tel;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/CMS.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var page_CMS = ({
  name: "CMS",
  data: function data() {
    return {
      loading: true,
      articleInfo: undefined
    };
  },
  mounted: function mounted() {
    this.init();
  },

  methods: {
    init: function init() {
      var _this = this;

      this.id = this.$route.query.id;
      if (this.id) {
        var that = this;
        this.loading = true;
        api.getArticle(this.id).then(function (res) {
          if (res.code === 20000 && res.data) {
            _this.articleInfo = res.data;
          }
          _this.loading = false;
        }).catch(function () {
          _this.loading = false;
        });
      }
    },
    callPhone: function callPhone() {
      window.location.href = "tel://" + this.tel;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e4bbfc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/CMS.vue
var CMS_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "article" }, [
    _c("div", { staticClass: "article-content" }, [
      _vm.articleInfo
        ? _c("div", { staticClass: "rich_media_area" }, [
            _c("div", { staticClass: "rich_media_area_primary" }, [
              _c("h2", { staticClass: "rich_media_title" }, [
                _vm._v(_vm._s(_vm.articleInfo.title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "rich_media_meta_list" }, [
                _c(
                  "span",
                  { staticClass: "rich_media_meta rich_media_meta_nickname" },
                  [_vm._v(_vm._s(_vm.articleInfo.author))]
                ),
                _vm._v(" "),
                _c(
                  "em",
                  { staticClass: "rich_media_meta rich_media_meta_text" },
                  [_vm._v(_vm._s(_vm.articleInfo.createDate))]
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "rich_media_content",
                staticStyle: { visibility: "visible" },
                domProps: { innerHTML: _vm._s(_vm.articleInfo.content) }
              })
            ]),
            _vm._v(" "),
            _vm.articleInfo.tel
              ? _c("div", { staticClass: "bottom" }, [
                  _c("div", { staticClass: "tel" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("热线电话:" + _vm._s(_vm.articleInfo.tel))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn", on: { click: _vm.callPhone } },
                    [_vm._v("立即拨打")]
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && !_vm.articleInfo
        ? _c("div", { staticClass: "none-content" }, [
            _c("img", {
              staticClass: "deleted",
              attrs: {
                src: __webpack_require__("VFIX")
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "mark" }, [
              _vm._v("该内容已被管理员删除")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var CMS_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: { src: __webpack_require__("6Rx/") }
      })
    ])
  }
]
CMS_render._withStripped = true
var CMS_esExports = { render: CMS_render, staticRenderFns: CMS_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_page_CMS = (CMS_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25e4bbfc", CMS_esExports)
  }
}
// CONCATENATED MODULE: ./src/page/CMS.vue
var CMS_disposed = false
function CMS_injectStyle (ssrContext) {
  if (CMS_disposed) return
  __webpack_require__("2aRu")
}
var CMS_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CMS___vue_template_functional__ = false
/* styles */
var CMS___vue_styles__ = CMS_injectStyle
/* scopeId */
var CMS___vue_scopeId__ = "data-v-25e4bbfc"
/* moduleIdentifier (server only) */
var CMS___vue_module_identifier__ = null
var CMS_Component = CMS_normalizeComponent(
  page_CMS,
  selectortype_template_index_0_src_page_CMS,
  CMS___vue_template_functional__,
  CMS___vue_styles__,
  CMS___vue_scopeId__,
  CMS___vue_module_identifier__
)
CMS_Component.options.__file = "src/page/CMS.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25e4bbfc", CMS_Component.options)
  } else {
    hotAPI.reload("data-v-25e4bbfc", CMS_Component.options)
  }
  module.hot.dispose(function (data) {
    CMS_disposed = true
  })
})()}

/* harmony default export */ var src_page_CMS = (CMS_Component.exports);

// EXTERNAL MODULE: ./node_modules/clipboard/dist/clipboard.js
var clipboard = __webpack_require__("TQvf");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(clipboard);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/BusSupport.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//注册到vue原型上
vue_esm["a" /* default */].prototype.clipboard = clipboard_default.a;

/* harmony default export */ var BusSupport = ({
  name: "busSupport",
  data: function data() {
    return {
      isSubscribe: false,
      navList: [{
        title: "支付方式",
        imgSrc: "../../static/images/busSupport/sim1.png",
        summary: "多种乘车买票方式，灵活选择"
      }, {
        title: "公交卡服务点",
        imgSrc: "../../static/images/busSupport/excellent.png",
        summary: "公交服务点，中国邮政代充点"
        // {
        //     title: '卡盟',
        //     imgSrc: '../../static/images/busSupport/bag.png',
        //     summary: '卖卡赚钱，佣金丰厚\n您的随身营业厅'
        // },
        // {
        //     title: '会员中心',
        //     imgSrc: '../../static/images/busSupport/member.png',
        //     summary: '专属特权，积分兑换\n彰显尊贵'
        // }
      }],
      busServerLists: [{
        name: "大安街",
        address: "南充市顺庆区半边街与大安街交叉口西50米"
      }, {
        name: "和平东路",
        address: "四川省南充市顺庆区和平东路51号"
      }],
      chinaPostLists: [{
        name: "镇江西路"
      }, {
        name: "西南石油大学"
      }, {
        name: "延安路"
      }, {
        name: "西华师大新区"
      }, {
        name: "人民中路"
      }, {
        name: "大北街"
      }, {
        name: "玉带中路"
      }, {
        name: "红光路"
      }, {
        name: "建设路"
      }, {
        name: "白塔路"
      }, {
        name: "望鹤路"
      }, {
        name: "火花路"
      }, {
        name: "光彩大市场"
      }],
      status: 0,
      //切换面板flag
      selected: true,
      selected1: false,
      selected2: false,
      selected3: false,
      temaiSelect: true,
      temaiSelect1: false,
      inputVal: "",
      holderText: "",
      showModelInfo: {
        btn: "确定"
      },
      downModelInfo: {
        showModelStatus: false,
        appImgSrc: "https://www.m10027.com/xiaochengxubanner/kmQRCode.png"
      },
      toastShow: false,
      toastText: ""
    };
  },
  methods: {
    getStatus: function getStatus(navStatus) {
      var navListData = this.navList;
      if (navStatus === 0) {
        navListData[0].imgSrc = "../../static/images/busSupport/sim1.png";
        navListData[1].imgSrc = "../../static/images/busSupport/excellent.png";
        // navListData[2].imgSrc = '../../static/images/busSupport/bag.png';
        // navListData[3].imgSrc = '../../static/images/busSupport/member.png';
        this.selected = true;
        this.selected1 = false;
        // this.selected2 = false;
        // this.selected3 = false;
      } else if (navStatus === 1) {
        navListData[0].imgSrc = "../../static/images/busSupport/sim.png";
        navListData[1].imgSrc = "../../static/images/busSupport/excellent1.png";
        // navListData[2].imgSrc = '../../static/images/busSupport/bag.png';
        // navListData[3].imgSrc = '../../static/images/busSupport/member.png';
        this.selected = false;
        this.selected1 = true;
        // this.selected2 = false;
        // this.selected3 = false;
      }
      // else if (navStatus === 2) {
      //     navListData[0].imgSrc = '../../static/images/busSupport/sim.png';
      //     navListData[1].imgSrc = '../../static/images/busSupport/excellent.png';
      //     navListData[2].imgSrc = '../../static/images/busSupport/bag1.png';
      //     navListData[3].imgSrc = '../../static/images/busSupport/member.png';
      //     this.selected = false;
      //     this.selected1 = false;
      //     this.selected2 = true;
      //     this.selected3 = false;
      // } else if (navStatus === 3) {
      //     navListData[0].imgSrc = '../../static/images/busSupport/sim.png';
      //     navListData[1].imgSrc = '../../static/images/busSupport/excellent.png';
      //     navListData[2].imgSrc = '../../static/images/busSupport/bag.png';
      //     navListData[3].imgSrc = '../../static/images/busSupport/member1.png';
      //     this.selected = false;
      //     this.selected1 = false;
      //     this.selected2 = false;
      //     this.selected3 = true;
      // };
      this.status = navStatus;
      this.navList = navListData;
    },

    //选择靓号特卖
    temaiSelectClick: function temaiSelectClick() {
      this.temaiSelect = true;
      this.temaiSelect1 = false;
    },
    //选择情侣号特卖
    temaiSelect1Click: function temaiSelect1Click() {
      this.temaiSelect = false;
      this.temaiSelect1 = true;
    },
    copyLink: function copyLink() {
      var _this = this;
      var clipboard = new this.clipboard(".busServerItem");
      clipboard.on("success", function () {
        _this.toast("复制成功");
      });
      clipboard.on("error", function () {
        _this.toast("复制失败");
      });
    },
    toast: function toast(str) {
      var v = this;
      v.toastText = str;
      v.toastShow = true;
      setTimeout(function () {
        v.toastShow = false;
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/BusSupport.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//注册到vue原型上
vue_esm["a" /* default */].prototype.clipboard = clipboard_default.a;

/* harmony default export */ var page_BusSupport = ({
  name: "busSupport",
  data: function data() {
    return {
      isSubscribe: false,
      navList: [{
        title: "支付方式",
        imgSrc: "../../static/images/busSupport/sim1.png",
        summary: "多种乘车买票方式，灵活选择"
      }, {
        title: "公交卡服务点",
        imgSrc: "../../static/images/busSupport/excellent.png",
        summary: "公交服务点，中国邮政代充点"
        // {
        //     title: '卡盟',
        //     imgSrc: '../../static/images/busSupport/bag.png',
        //     summary: '卖卡赚钱，佣金丰厚\n您的随身营业厅'
        // },
        // {
        //     title: '会员中心',
        //     imgSrc: '../../static/images/busSupport/member.png',
        //     summary: '专属特权，积分兑换\n彰显尊贵'
        // }
      }],
      busServerLists: [{
        name: "大安街",
        address: "南充市顺庆区半边街与大安街交叉口西50米"
      }, {
        name: "和平东路",
        address: "四川省南充市顺庆区和平东路51号"
      }],
      chinaPostLists: [{
        name: "镇江西路"
      }, {
        name: "西南石油大学"
      }, {
        name: "延安路"
      }, {
        name: "西华师大新区"
      }, {
        name: "人民中路"
      }, {
        name: "大北街"
      }, {
        name: "玉带中路"
      }, {
        name: "红光路"
      }, {
        name: "建设路"
      }, {
        name: "白塔路"
      }, {
        name: "望鹤路"
      }, {
        name: "火花路"
      }, {
        name: "光彩大市场"
      }],
      status: 0,
      //切换面板flag
      selected: true,
      selected1: false,
      selected2: false,
      selected3: false,
      temaiSelect: true,
      temaiSelect1: false,
      inputVal: "",
      holderText: "",
      showModelInfo: {
        btn: "确定"
      },
      downModelInfo: {
        showModelStatus: false,
        appImgSrc: "https://www.m10027.com/xiaochengxubanner/kmQRCode.png"
      },
      toastShow: false,
      toastText: ""
    };
  },
  methods: {
    getStatus: function getStatus(navStatus) {
      var navListData = this.navList;
      if (navStatus === 0) {
        navListData[0].imgSrc = "../../static/images/busSupport/sim1.png";
        navListData[1].imgSrc = "../../static/images/busSupport/excellent.png";
        // navListData[2].imgSrc = '../../static/images/busSupport/bag.png';
        // navListData[3].imgSrc = '../../static/images/busSupport/member.png';
        this.selected = true;
        this.selected1 = false;
        // this.selected2 = false;
        // this.selected3 = false;
      } else if (navStatus === 1) {
        navListData[0].imgSrc = "../../static/images/busSupport/sim.png";
        navListData[1].imgSrc = "../../static/images/busSupport/excellent1.png";
        // navListData[2].imgSrc = '../../static/images/busSupport/bag.png';
        // navListData[3].imgSrc = '../../static/images/busSupport/member.png';
        this.selected = false;
        this.selected1 = true;
        // this.selected2 = false;
        // this.selected3 = false;
      }
      // else if (navStatus === 2) {
      //     navListData[0].imgSrc = '../../static/images/busSupport/sim.png';
      //     navListData[1].imgSrc = '../../static/images/busSupport/excellent.png';
      //     navListData[2].imgSrc = '../../static/images/busSupport/bag1.png';
      //     navListData[3].imgSrc = '../../static/images/busSupport/member.png';
      //     this.selected = false;
      //     this.selected1 = false;
      //     this.selected2 = true;
      //     this.selected3 = false;
      // } else if (navStatus === 3) {
      //     navListData[0].imgSrc = '../../static/images/busSupport/sim.png';
      //     navListData[1].imgSrc = '../../static/images/busSupport/excellent.png';
      //     navListData[2].imgSrc = '../../static/images/busSupport/bag.png';
      //     navListData[3].imgSrc = '../../static/images/busSupport/member1.png';
      //     this.selected = false;
      //     this.selected1 = false;
      //     this.selected2 = false;
      //     this.selected3 = true;
      // };
      this.status = navStatus;
      this.navList = navListData;
    },

    //选择靓号特卖
    temaiSelectClick: function temaiSelectClick() {
      this.temaiSelect = true;
      this.temaiSelect1 = false;
    },
    //选择情侣号特卖
    temaiSelect1Click: function temaiSelect1Click() {
      this.temaiSelect = false;
      this.temaiSelect1 = true;
    },
    copyLink: function copyLink() {
      var _this = this;
      var clipboard = new this.clipboard(".busServerItem");
      clipboard.on("success", function () {
        _this.toast("复制成功");
      });
      clipboard.on("error", function () {
        _this.toast("复制失败");
      });
    },
    toast: function toast(str) {
      var v = this;
      v.toastText = str;
      v.toastShow = true;
      setTimeout(function () {
        v.toastShow = false;
      }, 1500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c3b0686","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/BusSupport.vue
var BusSupport_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index-wrap" }, [
    _c("div", { staticClass: "tabWrap" }, [
      _c("div", { staticClass: "scrollCon" }, [
        _c(
          "div",
          {
            attrs: {
              "scroll-into-view": "NAV" + _vm.status,
              "scroll-with-animation": "true"
            }
          },
          [
            _c(
              "div",
              { staticClass: "scroll-view-x" },
              _vm._l(_vm.navList, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticStyle: { "padding-left": "5px" } },
                  [
                    _c(
                      "div",
                      {
                        class: "scrollpadding" + index,
                        attrs: { id: "NAV" + index, "data-index": index },
                        on: {
                          click: function($event) {
                            return _vm.getStatus(index)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            class: index === _vm.status ? "selected" : "default"
                          },
                          [
                            _c("label", { staticClass: "itemtitle" }, [
                              _vm._v(_vm._s(item.title))
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              class:
                                index === _vm.status
                                  ? "selectImg biger"
                                  : "selectImg small",
                              attrs: { src: item.imgSrc }
                            }),
                            _vm._v(" "),
                            _c("label", { staticClass: "itemsummary" }, [
                              _vm._v(_vm._s(item.summary))
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "switchBoard" }, [
        _c("div", { class: _vm.selected ? "show" : "hidden" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "0.5px" } })
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.selected1 ? "show" : "hidden" }, [
          _c("div", { staticClass: "icCardBoard" }, [
            _c("div", { staticClass: "icCardTab" }, [
              _c(
                "div",
                {
                  class: _vm.temaiSelect ? "temaiselected" : "temaidefault",
                  on: { click: _vm.temaiSelectClick }
                },
                [_c("span", { staticClass: "title" }, [_vm._v("公交服务点")])]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "line" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.temaiSelect1 ? "temaiselected" : "temaidefault",
                  on: { click: _vm.temaiSelect1Click }
                },
                [_c("span", { staticClass: "title" }, [_vm._v("邮政代办点")])]
              )
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.temaiSelect ? "show" : "hidden" }, [
              _c(
                "div",
                { staticClass: "busServerBorad" },
                [
                  _vm._l(_vm.busServerLists, function(item) {
                    return _c(
                      "div",
                      { key: item.name, staticClass: "busServerItem" },
                      [
                        _c("label", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.name))
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "address" }, [
                          _vm._v(_vm._s(item.address))
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "busServerItem",
                      attrs: {
                        "data-clipboard-text": "http://www.fbchong.com"
                      },
                      on: { click: _vm.copyLink }
                    },
                    [
                      _c("label", { staticClass: "name" }, [
                        _vm._v("网上充值")
                      ]),
                      _vm._v(" "),
                      _vm._m(1)
                    ]
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.temaiSelect1 ? "show" : "hidden" }, [
              _c(
                "div",
                { staticClass: "busServerBorad" },
                _vm._l(_vm.chinaPostLists, function(item) {
                  return _c(
                    "div",
                    { key: item.name, staticClass: "busServerItem" },
                    [
                      _c("label", { staticClass: "name" }, [
                        _vm._v(_vm._s(item.name))
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb" })
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.toastShow,
            expression: "toastShow"
          }
        ],
        staticClass: "toast"
      },
      [_vm._v("\n    " + _vm._s(_vm.toastText) + "\n  ")]
    )
  ])
}
var BusSupport_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "goukaboard" }, [
      _c("div", { staticClass: "goukason goukason3" }, [
        _c("label", { staticClass: "title" }, [_vm._v("公交卡")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("服务窗口：公交服务点，邮政代办点"),
          _c("br"),
          _vm._v("\n              网上充值：方便充APP")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: __webpack_require__("i/qG") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukason5" }, [
        _c("label", { staticClass: "title" }, [_vm._v("银联卡")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("62开头带芯片，有银联标识，有闪付标识 "),
          _c("br"),
          _vm._v("\n              需开通小额免密支付功能")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: __webpack_require__("l7ic") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukasonWechat" }, [
        _c("label", { staticClass: "title" }, [_vm._v("微信乘车码")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v('微信小程序搜"乘车码"，选择南充市')
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: __webpack_require__("i/qG") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukason1" }, [
        _c("label", { staticClass: "title" }, [_vm._v("支付宝乘车码")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("支付宝APP首页搜索：南充市乘车码")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: __webpack_require__("RF85") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukason2" }, [
        _c("label", { staticClass: "title" }, [_vm._v("云闪付乘车码")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("云闪付APP，绑定任意银联卡，选择南充市")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: __webpack_require__("6/lx") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukason4" }, [
        _c("label", { staticClass: "title" }, [_vm._v("天府银行乘车码")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("天府手机银行APP，绑定天府银行卡")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: __webpack_require__("iwBE") }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "address" }, [
      _vm._v("点击此处复制方便充APP地址："),
      _c("br"),
      _vm._v("\n                  http://www.fbchong.com")
    ])
  }
]
BusSupport_render._withStripped = true
var BusSupport_esExports = { render: BusSupport_render, staticRenderFns: BusSupport_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_page_BusSupport = (BusSupport_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c3b0686", BusSupport_esExports)
  }
}
// CONCATENATED MODULE: ./src/page/BusSupport.vue
var BusSupport_disposed = false
function BusSupport_injectStyle (ssrContext) {
  if (BusSupport_disposed) return
  __webpack_require__("cUcc")
}
var BusSupport_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BusSupport___vue_template_functional__ = false
/* styles */
var BusSupport___vue_styles__ = BusSupport_injectStyle
/* scopeId */
var BusSupport___vue_scopeId__ = "data-v-3c3b0686"
/* moduleIdentifier (server only) */
var BusSupport___vue_module_identifier__ = null
var BusSupport_Component = BusSupport_normalizeComponent(
  page_BusSupport,
  selectortype_template_index_0_src_page_BusSupport,
  BusSupport___vue_template_functional__,
  BusSupport___vue_styles__,
  BusSupport___vue_scopeId__,
  BusSupport___vue_module_identifier__
)
BusSupport_Component.options.__file = "src/page/BusSupport.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c3b0686", BusSupport_Component.options)
  } else {
    hotAPI.reload("data-v-3c3b0686", BusSupport_Component.options)
  }
  module.hot.dispose(function (data) {
    BusSupport_disposed = true
  })
})()}

/* harmony default export */ var src_page_BusSupport = (BusSupport_Component.exports);

// CONCATENATED MODULE: ./src/page/miniUrl/miniQrcode.js

/* harmony default export */ var miniQrcode = ({
  data: function data() {
    return {
      params: {
        platform: 'browser',
        keycode: 'QRCODE'
      }
    };
  },
  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      if (/MicroMessenger/.test(window.navigator.userAgent)) {
        //微信内打开：进小程序码长按识别页
        this.params.platform = "weixin";
        this.saveVistRecord();
        window.location.href = '/#/wechat';
      } else if (/AlipayClient/.test(window.navigator.userAgent)) {
        this.params.platform = "alipay";
        this.saveVistRecord();
        window.location.href = '/#/alipay';
      } else {
        //相机、浏览器等其他软件：引导页提示改用微信扫一扫
        this.params.platform = "browser";
        this.saveVistRecord();
        window.location.href = '/#/browser';
      }
    },

    // 访问统计上报：gcx-realtime-bus /appApi/statistics/h5Visit（原 /api/miniprogram 接口已死，勿改回）
    saveVistRecord: function saveVistRecord() {
      api.h5VisitReport(this.params).then(function (res) {}).catch(function (err) {});
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283f02c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/miniUrl/tips.vue
var tips_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var tips_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "top" }, [
        _c("img", {
          staticClass: "title",
          attrs: { src: __webpack_require__("NSaQ") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "searchMark",
          attrs: { src: __webpack_require__("NcXw") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "search",
          attrs: { src: __webpack_require__("9YoK") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "appUi",
          attrs: { src: __webpack_require__("SLZn") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }, [
        _c("img", {
          staticClass: "logoIcon",
          attrs: { src: __webpack_require__("E+dh") }
        })
      ])
    ])
  }
]
tips_render._withStripped = true
var tips_esExports = { render: tips_render, staticRenderFns: tips_staticRenderFns }
/* harmony default export */ var tips = (tips_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-283f02c6", tips_esExports)
  }
}
// CONCATENATED MODULE: ./src/page/miniUrl/tips.vue
var tips_disposed = false
function tips_injectStyle (ssrContext) {
  if (tips_disposed) return
  __webpack_require__("WH3E")
}
var tips_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var tips___vue_template_functional__ = false
/* styles */
var tips___vue_styles__ = tips_injectStyle
/* scopeId */
var tips___vue_scopeId__ = "data-v-283f02c6"
/* moduleIdentifier (server only) */
var tips___vue_module_identifier__ = null
var tips_Component = tips_normalizeComponent(
  __vue_script__,
  tips,
  tips___vue_template_functional__,
  tips___vue_styles__,
  tips___vue_scopeId__,
  tips___vue_module_identifier__
)
tips_Component.options.__file = "src/page/miniUrl/tips.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-283f02c6", tips_Component.options)
  } else {
    hotAPI.reload("data-v-283f02c6", tips_Component.options)
  }
  module.hot.dispose(function (data) {
    tips_disposed = true
  })
})()}

/* harmony default export */ var miniUrl_tips = (tips_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/miniUrl/alipay.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var alipay = ({
  name: 'alipay',
  data: function data() {
    return {
      detectedApp: '系统相机 / 浏览器'
    };
  },
  mounted: function mounted() {
    var ua = window.navigator.userAgent || '';
    if (/AlipayClient/i.test(ua)) {
      this.detectedApp = '支付宝';
    } else if (/QQ\/|MQQBrowser/i.test(ua)) {
      this.detectedApp = 'QQ';
    } else if (/Quark/i.test(ua)) {
      this.detectedApp = '夸克浏览器';
    } else if (/UCBrowser|UCWEB/i.test(ua)) {
      this.detectedApp = 'UC浏览器';
    } else if (/baiduboxapp|BaiduHost/i.test(ua)) {
      this.detectedApp = '百度';
    } else if (/aweme|Bytedance|douyin|ByteLocale/i.test(ua)) {
      this.detectedApp = '抖音';
    } else if (/DingTalk/i.test(ua)) {
      this.detectedApp = '钉钉';
    } else if (/MicroMessenger/i.test(ua)) {
      this.detectedApp = '微信';
    } else if (/VivoBrowser|HeyTapBrowser|HUAWEIBrowser|MiuiBrowser|HONOR/i.test(ua)) {
      this.detectedApp = '手机自带浏览器';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/miniUrl/alipay.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var miniUrl_alipay = ({
  name: 'alipay',
  data: function data() {
    return {
      detectedApp: '系统相机 / 浏览器'
    };
  },
  mounted: function mounted() {
    var ua = window.navigator.userAgent || '';
    if (/AlipayClient/i.test(ua)) {
      this.detectedApp = '支付宝';
    } else if (/QQ\/|MQQBrowser/i.test(ua)) {
      this.detectedApp = 'QQ';
    } else if (/Quark/i.test(ua)) {
      this.detectedApp = '夸克浏览器';
    } else if (/UCBrowser|UCWEB/i.test(ua)) {
      this.detectedApp = 'UC浏览器';
    } else if (/baiduboxapp|BaiduHost/i.test(ua)) {
      this.detectedApp = '百度';
    } else if (/aweme|Bytedance|douyin|ByteLocale/i.test(ua)) {
      this.detectedApp = '抖音';
    } else if (/DingTalk/i.test(ua)) {
      this.detectedApp = '钉钉';
    } else if (/MicroMessenger/i.test(ua)) {
      this.detectedApp = '微信';
    } else if (/VivoBrowser|HeyTapBrowser|HUAWEIBrowser|MiuiBrowser|HONOR/i.test(ua)) {
      this.detectedApp = '手机自带浏览器';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddcc4950","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/miniUrl/alipay.vue
var alipay_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scan-guide" }, [
    _c("header", { staticClass: "brand" }, [
      _c("span", { staticClass: "brand-ic" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 64 34",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("rect", {
              attrs: {
                x: "2",
                y: "2",
                width: "56",
                height: "24",
                rx: "7",
                fill: "#fff"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "2",
                y: "20",
                width: "56",
                height: "3",
                fill: "#07c160"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "7",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "20",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "33",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "46",
                y: "7",
                width: "7",
                height: "16",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("果城行丨公共出行服务查询")])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "card" }, [
      _c("div", { staticClass: "frame" }, [
        _c("i", { staticClass: "c c1" }),
        _c("i", { staticClass: "c c2" }),
        _c("i", { staticClass: "c c3" }),
        _c("i", { staticClass: "c c4" }),
        _vm._v(" "),
        _c("div", { staticClass: "frame-inner" }, [
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 120 100",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: { d: "M97 88 L101 99 L86 92 Z", fill: "#0BBF6B" }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "83",
                  cy: "68",
                  rx: "27",
                  ry: "21",
                  fill: "#0BBF6B"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "74",
                  cy: "67",
                  rx: "3.2",
                  ry: "3.9",
                  fill: "#fff"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "93",
                  cy: "67",
                  rx: "3.2",
                  ry: "3.9",
                  fill: "#fff"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: { d: "M31 65 L24 84 L47 70 Z", fill: "#07C160" }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "43",
                  cy: "38",
                  rx: "34",
                  ry: "27",
                  fill: "#07C160"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "32",
                  cy: "35",
                  rx: "3.6",
                  ry: "4.4",
                  fill: "#fff"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "55",
                  cy: "35",
                  rx: "3.6",
                  ry: "4.4",
                  fill: "#fff"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "scanline" })
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "frame-cap" }, [_vm._v("仅限微信扫码进入")]),
      _vm._v(" "),
      _c("div", { staticClass: "app-badge" }, [
        _c("span", { staticClass: "dot" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "检测到「" + _vm._s(_vm.detectedApp) + "」打开 · 无法进入小程序"
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "banner-tip" }, [
        _vm._v("🚌 公交到站实时查询 · 无需下载 · 微信扫码即用")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "road" }, [
      _c(
        "svg",
        {
          staticClass: "bus",
          attrs: {
            viewBox: "0 0 64 34",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("rect", {
            attrs: {
              x: "2",
              y: "2",
              width: "56",
              height: "24",
              rx: "7",
              fill: "#ffffff"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "2",
              y: "20",
              width: "56",
              height: "3",
              fill: "#07c160"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "7",
              y: "7",
              width: "9",
              height: "9",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "20",
              y: "7",
              width: "9",
              height: "9",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "33",
              y: "7",
              width: "9",
              height: "9",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "46",
              y: "7",
              width: "7",
              height: "16",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
          }),
          _c("circle", {
            attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
          }),
          _c("circle", {
            attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("footer", { staticClass: "foot" }, [
      _vm._v("南充七安网络科技有限公司 · 提供技术支持")
    ])
  ])
}
var alipay_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _vm._v("请用"),
      _c("em", [_vm._v("微信扫一扫")]),
      _c("br"),
      _vm._v("进入小程序")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "sub" }, [
      _vm._v("\n      站台二维码对应"),
      _c("strong", [_vm._v("微信小程序")]),
      _c("br"),
      _vm._v("\n      相机、支付宝、浏览器等软件扫码均无法打开\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "steps" }, [
      _c("li", [
        _c("span", { staticClass: "num" }, [_vm._v("1")]),
        _c("span", [
          _vm._v("打开"),
          _c("b", [_vm._v("微信")]),
          _vm._v("，点右上角"),
          _c("span", { staticClass: "plus" }, [_vm._v("＋")])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "num" }, [_vm._v("2")]),
        _c("span", [_vm._v("选择"), _c("b", [_vm._v("「扫一扫」")])])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "num" }, [_vm._v("3")]),
        _c("span", [_vm._v("对准站台上的二维码，即可进入小程序")])
      ])
    ])
  }
]
alipay_render._withStripped = true
var alipay_esExports = { render: alipay_render, staticRenderFns: alipay_staticRenderFns }
/* harmony default export */ var page_miniUrl_alipay = (alipay_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddcc4950", alipay_esExports)
  }
}
// CONCATENATED MODULE: ./src/page/miniUrl/alipay.vue
var alipay_disposed = false
function alipay_injectStyle (ssrContext) {
  if (alipay_disposed) return
  __webpack_require__("QHGZ")
}
var alipay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var alipay___vue_template_functional__ = false
/* styles */
var alipay___vue_styles__ = alipay_injectStyle
/* scopeId */
var alipay___vue_scopeId__ = "data-v-ddcc4950"
/* moduleIdentifier (server only) */
var alipay___vue_module_identifier__ = null
var alipay_Component = alipay_normalizeComponent(
  miniUrl_alipay,
  page_miniUrl_alipay,
  alipay___vue_template_functional__,
  alipay___vue_styles__,
  alipay___vue_scopeId__,
  alipay___vue_module_identifier__
)
alipay_Component.options.__file = "src/page/miniUrl/alipay.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ddcc4950", alipay_Component.options)
  } else {
    hotAPI.reload("data-v-ddcc4950", alipay_Component.options)
  }
  module.hot.dispose(function (data) {
    alipay_disposed = true
  })
})()}

/* harmony default export */ var src_page_miniUrl_alipay = (alipay_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6acb2e34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/miniUrl/wechat.vue
var wechat_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var wechat_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wechat" }, [
      _c("div", { staticClass: "top" }, [
        _c("p", { staticClass: "title" }, [_vm._v("果城行丨公共出行服务查询")]),
        _vm._v(" "),
        _c("p", { staticClass: "mark" }, [
          _vm._v("即时查看公交到站信息 "),
          _c("span", [_vm._v("合理出行")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mark" }, [_vm._v("查车乘车一站式服务")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "image-content" }, [
        _c("img", {
          attrs: {
            src: __webpack_require__("ijc4")
          }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "tips" }, [_vm._v("长按识别二维码进入小程序")])
      ])
    ])
  }
]
wechat_render._withStripped = true
var wechat_esExports = { render: wechat_render, staticRenderFns: wechat_staticRenderFns }
/* harmony default export */ var wechat = (wechat_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6acb2e34", wechat_esExports)
  }
}
// CONCATENATED MODULE: ./src/page/miniUrl/wechat.vue
var wechat_disposed = false
function wechat_injectStyle (ssrContext) {
  if (wechat_disposed) return
  __webpack_require__("QXZ8")
}
var wechat_normalizeComponent = __webpack_require__("VU/8")
/* script */
var wechat___vue_script__ = null
/* template */

/* template functional */
var wechat___vue_template_functional__ = false
/* styles */
var wechat___vue_styles__ = wechat_injectStyle
/* scopeId */
var wechat___vue_scopeId__ = "data-v-6acb2e34"
/* moduleIdentifier (server only) */
var wechat___vue_module_identifier__ = null
var wechat_Component = wechat_normalizeComponent(
  wechat___vue_script__,
  wechat,
  wechat___vue_template_functional__,
  wechat___vue_styles__,
  wechat___vue_scopeId__,
  wechat___vue_module_identifier__
)
wechat_Component.options.__file = "src/page/miniUrl/wechat.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6acb2e34", wechat_Component.options)
  } else {
    hotAPI.reload("data-v-6acb2e34", wechat_Component.options)
  }
  module.hot.dispose(function (data) {
    wechat_disposed = true
  })
})()}

/* harmony default export */ var miniUrl_wechat = (wechat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/miniUrl/browser.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var browser = ({
  name: 'browser',
  data: function data() {
    return {
      detectedApp: '系统相机 / 浏览器'
    };
  },
  mounted: function mounted() {
    var ua = window.navigator.userAgent || '';
    if (/AlipayClient/i.test(ua)) {
      this.detectedApp = '支付宝';
    } else if (/QQ\/|MQQBrowser/i.test(ua)) {
      this.detectedApp = 'QQ';
    } else if (/Quark/i.test(ua)) {
      this.detectedApp = '夸克浏览器';
    } else if (/UCBrowser|UCWEB/i.test(ua)) {
      this.detectedApp = 'UC浏览器';
    } else if (/baiduboxapp|BaiduHost/i.test(ua)) {
      this.detectedApp = '百度';
    } else if (/aweme|Bytedance|douyin|ByteLocale/i.test(ua)) {
      this.detectedApp = '抖音';
    } else if (/DingTalk/i.test(ua)) {
      this.detectedApp = '钉钉';
    } else if (/MicroMessenger/i.test(ua)) {
      this.detectedApp = '微信';
    } else if (/VivoBrowser|HeyTapBrowser|HUAWEIBrowser|MiuiBrowser|HONOR/i.test(ua)) {
      this.detectedApp = '手机自带浏览器';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/miniUrl/browser.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var miniUrl_browser = ({
  name: 'browser',
  data: function data() {
    return {
      detectedApp: '系统相机 / 浏览器'
    };
  },
  mounted: function mounted() {
    var ua = window.navigator.userAgent || '';
    if (/AlipayClient/i.test(ua)) {
      this.detectedApp = '支付宝';
    } else if (/QQ\/|MQQBrowser/i.test(ua)) {
      this.detectedApp = 'QQ';
    } else if (/Quark/i.test(ua)) {
      this.detectedApp = '夸克浏览器';
    } else if (/UCBrowser|UCWEB/i.test(ua)) {
      this.detectedApp = 'UC浏览器';
    } else if (/baiduboxapp|BaiduHost/i.test(ua)) {
      this.detectedApp = '百度';
    } else if (/aweme|Bytedance|douyin|ByteLocale/i.test(ua)) {
      this.detectedApp = '抖音';
    } else if (/DingTalk/i.test(ua)) {
      this.detectedApp = '钉钉';
    } else if (/MicroMessenger/i.test(ua)) {
      this.detectedApp = '微信';
    } else if (/VivoBrowser|HeyTapBrowser|HUAWEIBrowser|MiuiBrowser|HONOR/i.test(ua)) {
      this.detectedApp = '手机自带浏览器';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a2f5ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/miniUrl/browser.vue
var browser_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scan-guide" }, [
    _c("header", { staticClass: "brand" }, [
      _c("span", { staticClass: "brand-ic" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 64 34",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("rect", {
              attrs: {
                x: "2",
                y: "2",
                width: "56",
                height: "24",
                rx: "7",
                fill: "#fff"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "2",
                y: "20",
                width: "56",
                height: "3",
                fill: "#07c160"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "7",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "20",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "33",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "46",
                y: "7",
                width: "7",
                height: "16",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("果城行丨公共出行服务查询")])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "card" }, [
      _c("div", { staticClass: "frame" }, [
        _c("i", { staticClass: "c c1" }),
        _c("i", { staticClass: "c c2" }),
        _c("i", { staticClass: "c c3" }),
        _c("i", { staticClass: "c c4" }),
        _vm._v(" "),
        _c("div", { staticClass: "frame-inner" }, [
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 120 100",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: { d: "M97 88 L101 99 L86 92 Z", fill: "#0BBF6B" }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "83",
                  cy: "68",
                  rx: "27",
                  ry: "21",
                  fill: "#0BBF6B"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "74",
                  cy: "67",
                  rx: "3.2",
                  ry: "3.9",
                  fill: "#fff"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "93",
                  cy: "67",
                  rx: "3.2",
                  ry: "3.9",
                  fill: "#fff"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: { d: "M31 65 L24 84 L47 70 Z", fill: "#07C160" }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "43",
                  cy: "38",
                  rx: "34",
                  ry: "27",
                  fill: "#07C160"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "32",
                  cy: "35",
                  rx: "3.6",
                  ry: "4.4",
                  fill: "#fff"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "55",
                  cy: "35",
                  rx: "3.6",
                  ry: "4.4",
                  fill: "#fff"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "scanline" })
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "frame-cap" }, [_vm._v("仅限微信扫码进入")]),
      _vm._v(" "),
      _c("div", { staticClass: "app-badge" }, [
        _c("span", { staticClass: "dot" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "检测到「" + _vm._s(_vm.detectedApp) + "」打开 · 无法进入小程序"
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "banner-tip" }, [
        _vm._v("🚌 公交到站实时查询 · 无需下载 · 微信扫码即用")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "road" }, [
      _c(
        "svg",
        {
          staticClass: "bus",
          attrs: {
            viewBox: "0 0 64 34",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("rect", {
            attrs: {
              x: "2",
              y: "2",
              width: "56",
              height: "24",
              rx: "7",
              fill: "#ffffff"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "2",
              y: "20",
              width: "56",
              height: "3",
              fill: "#07c160"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "7",
              y: "7",
              width: "9",
              height: "9",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "20",
              y: "7",
              width: "9",
              height: "9",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "33",
              y: "7",
              width: "9",
              height: "9",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "46",
              y: "7",
              width: "7",
              height: "16",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
          }),
          _c("circle", {
            attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
          }),
          _c("circle", {
            attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("footer", { staticClass: "foot" }, [
      _vm._v("南充七安网络科技有限公司 · 提供技术支持")
    ])
  ])
}
var browser_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _vm._v("请用"),
      _c("em", [_vm._v("微信扫一扫")]),
      _c("br"),
      _vm._v("进入小程序")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "sub" }, [
      _vm._v("\n      站台二维码对应"),
      _c("strong", [_vm._v("微信小程序")]),
      _c("br"),
      _vm._v("\n      相机、支付宝、浏览器等软件扫码均无法打开\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "steps" }, [
      _c("li", [
        _c("span", { staticClass: "num" }, [_vm._v("1")]),
        _c("span", [
          _vm._v("打开"),
          _c("b", [_vm._v("微信")]),
          _vm._v("，点右上角"),
          _c("span", { staticClass: "plus" }, [_vm._v("＋")])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "num" }, [_vm._v("2")]),
        _c("span", [_vm._v("选择"), _c("b", [_vm._v("「扫一扫」")])])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "num" }, [_vm._v("3")]),
        _c("span", [_vm._v("对准站台上的二维码，即可进入小程序")])
      ])
    ])
  }
]
browser_render._withStripped = true
var browser_esExports = { render: browser_render, staticRenderFns: browser_staticRenderFns }
/* harmony default export */ var page_miniUrl_browser = (browser_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69a2f5ec", browser_esExports)
  }
}
// CONCATENATED MODULE: ./src/page/miniUrl/browser.vue
var browser_disposed = false
function browser_injectStyle (ssrContext) {
  if (browser_disposed) return
  __webpack_require__("HxK8")
}
var browser_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var browser___vue_template_functional__ = false
/* styles */
var browser___vue_styles__ = browser_injectStyle
/* scopeId */
var browser___vue_scopeId__ = "data-v-69a2f5ec"
/* moduleIdentifier (server only) */
var browser___vue_module_identifier__ = null
var browser_Component = browser_normalizeComponent(
  miniUrl_browser,
  page_miniUrl_browser,
  browser___vue_template_functional__,
  browser___vue_styles__,
  browser___vue_scopeId__,
  browser___vue_module_identifier__
)
browser_Component.options.__file = "src/page/miniUrl/browser.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-69a2f5ec", browser_Component.options)
  } else {
    hotAPI.reload("data-v-69a2f5ec", browser_Component.options)
  }
  module.hot.dispose(function (data) {
    browser_disposed = true
  })
})()}

/* harmony default export */ var src_page_miniUrl_browser = (browser_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/miniUrl/window.vue
//
//
//
//
//
//


/* harmony default export */ var miniUrl_window = ({
    name: 'window',
    data: function data() {},
    mounted: function mounted() {
        this.init();
    },

    methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/miniUrl/window.vue
//
//
//
//
//
//


/* harmony default export */ var page_miniUrl_window = ({
    name: 'window',
    data: function data() {},
    mounted: function mounted() {
        this.init();
    },

    methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ff09fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/miniUrl/window.vue
var window_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var window_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "window" }, [
      _c("img", {
        staticClass: "top-image",
        attrs: {
          src: __webpack_require__("n1YV")
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "bottom-image",
        attrs: {
          src: __webpack_require__("L7S0")
        }
      })
    ])
  }
]
window_render._withStripped = true
var window_esExports = { render: window_render, staticRenderFns: window_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_page_miniUrl_window = (window_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76ff09fe", window_esExports)
  }
}
// CONCATENATED MODULE: ./src/page/miniUrl/window.vue
var window_disposed = false
function window_injectStyle (ssrContext) {
  if (window_disposed) return
  __webpack_require__("okab")
}
var window_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var window___vue_template_functional__ = false
/* styles */
var window___vue_styles__ = window_injectStyle
/* scopeId */
var window___vue_scopeId__ = "data-v-76ff09fe"
/* moduleIdentifier (server only) */
var window___vue_module_identifier__ = null
var window_Component = window_normalizeComponent(
  page_miniUrl_window,
  selectortype_template_index_0_src_page_miniUrl_window,
  window___vue_template_functional__,
  window___vue_styles__,
  window___vue_scopeId__,
  window___vue_module_identifier__
)
window_Component.options.__file = "src/page/miniUrl/window.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-76ff09fe", window_Component.options)
  } else {
    hotAPI.reload("data-v-76ff09fe", window_Component.options)
  }
  module.hot.dispose(function (data) {
    window_disposed = true
  })
})()}

/* harmony default export */ var src_page_miniUrl_window = (window_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/AlipayRedEnvelope/ncljlPromote.vue
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ncljlPromote = ({
  name: "window",
  data: function data() {},
  mounted: function mounted() {
    this.init();
  },

  methods: {}
});

document.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {
  // 通过下面这个API隐藏右上角按钮
  WeixinJSBridge.call("hideOptionMenu"); // 通过下面这个API隐藏底部导航栏
  WeixinJSBridge.call("hideToolbar");
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/AlipayRedEnvelope/ncljlPromote.vue
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var AlipayRedEnvelope_ncljlPromote = ({
  name: "window",
  data: function data() {},
  mounted: function mounted() {
    this.init();
  },

  methods: {}
});

document.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {
  // 通过下面这个API隐藏右上角按钮
  WeixinJSBridge.call("hideOptionMenu"); // 通过下面这个API隐藏底部导航栏
  WeixinJSBridge.call("hideToolbar");
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-315574b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/AlipayRedEnvelope/ncljlPromote.vue
var ncljlPromote_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var ncljlPromote_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ncojl-promote" }, [
      _c("img", {
        staticClass: "top-image",
        attrs: {
          src: __webpack_require__("n1YV")
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "bottom-image",
        attrs: {
          src: __webpack_require__("BWPK")
        }
      })
    ])
  }
]
ncljlPromote_render._withStripped = true
var ncljlPromote_esExports = { render: ncljlPromote_render, staticRenderFns: ncljlPromote_staticRenderFns }
/* harmony default export */ var page_AlipayRedEnvelope_ncljlPromote = (ncljlPromote_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-315574b6", ncljlPromote_esExports)
  }
}
// CONCATENATED MODULE: ./src/page/AlipayRedEnvelope/ncljlPromote.vue
var ncljlPromote_disposed = false
function ncljlPromote_injectStyle (ssrContext) {
  if (ncljlPromote_disposed) return
  __webpack_require__("9usb")
}
var ncljlPromote_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ncljlPromote___vue_template_functional__ = false
/* styles */
var ncljlPromote___vue_styles__ = ncljlPromote_injectStyle
/* scopeId */
var ncljlPromote___vue_scopeId__ = "data-v-315574b6"
/* moduleIdentifier (server only) */
var ncljlPromote___vue_module_identifier__ = null
var ncljlPromote_Component = ncljlPromote_normalizeComponent(
  AlipayRedEnvelope_ncljlPromote,
  page_AlipayRedEnvelope_ncljlPromote,
  ncljlPromote___vue_template_functional__,
  ncljlPromote___vue_styles__,
  ncljlPromote___vue_scopeId__,
  ncljlPromote___vue_module_identifier__
)
ncljlPromote_Component.options.__file = "src/page/AlipayRedEnvelope/ncljlPromote.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-315574b6", ncljlPromote_Component.options)
  } else {
    hotAPI.reload("data-v-315574b6", ncljlPromote_Component.options)
  }
  module.hot.dispose(function (data) {
    ncljlPromote_disposed = true
  })
})()}

/* harmony default export */ var src_page_AlipayRedEnvelope_ncljlPromote = (ncljlPromote_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vant/es/toast/style/index.js
var style = __webpack_require__("eqfM");

// EXTERNAL MODULE: ./node_modules/vant/es/toast/index.js
var toast = __webpack_require__("/QYm");

// EXTERNAL MODULE: ./node_modules/vant/es/button/style/index.js
var button_style = __webpack_require__("3Lne");

// EXTERNAL MODULE: ./node_modules/vant/es/button/index.js + 1 modules
var es_button = __webpack_require__("SSsa");

// EXTERNAL MODULE: ./node_modules/vant/es/field/style/index.js
var field_style = __webpack_require__("MY4N");

// EXTERNAL MODULE: ./node_modules/vant/es/field/index.js + 5 modules
var field = __webpack_require__("0zAV");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/collectCustomerInfo/studentDriver/blueSkySt.vue






 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _components;



/* harmony default export */ var blueSkySt = ({
  name: "BlueSkySt",
  components: (_components = {}, defineProperty_default()(_components, field["a" /* default */].name, field["a" /* default */]), defineProperty_default()(_components, es_button["a" /* default */].name, es_button["a" /* default */]), defineProperty_default()(_components, toast["a" /* default */].name, toast["a" /* default */]), _components),
  data: function data() {
    return {
      mobile: ''
    };
  },

  methods: {
    bindBobile: function bindBobile() {
      if (!this.mobile || this.mobile.length === 0) {
        Object(toast["a" /* default */])({
          message: "请输入手机号",
          icon: "edit"
        });
        return;
      }
      if (this.mobile.length !== 11) {
        Object(toast["a" /* default */])({
          message: "手机号错误",
          icon: "phone-o"
        });
        return;
      }
      toast["a" /* default */].loading({
        message: "领取中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0
      });
      var adData = {
        type: "LANTIAN_JIAXIAO",
        name: "南职蓝天驾校用户信息",
        reservedOne: this.mobile
      };
      api.setAdRecord(adData).then(function () {
        toast["a" /* default */].clear();
        Object(toast["a" /* default */])({
          message: "领取成功",
          icon: "medal-o"
        });
      }).catch(function (e) {
        toast["a" /* default */].clear();
        Object(toast["a" /* default */])({
          message: "领取失败",
          icon: "smile-o"
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/page/collectCustomerInfo/studentDriver/blueSkySt.vue






 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var blueSkySt__components;



/* harmony default export */ var studentDriver_blueSkySt = ({
  name: "BlueSkySt",
  components: (blueSkySt__components = {}, defineProperty_default()(blueSkySt__components, field["a" /* default */].name, field["a" /* default */]), defineProperty_default()(blueSkySt__components, es_button["a" /* default */].name, es_button["a" /* default */]), defineProperty_default()(blueSkySt__components, toast["a" /* default */].name, toast["a" /* default */]), blueSkySt__components),
  data: function data() {
    return {
      mobile: ''
    };
  },

  methods: {
    bindBobile: function bindBobile() {
      if (!this.mobile || this.mobile.length === 0) {
        Object(toast["a" /* default */])({
          message: "请输入手机号",
          icon: "edit"
        });
        return;
      }
      if (this.mobile.length !== 11) {
        Object(toast["a" /* default */])({
          message: "手机号错误",
          icon: "phone-o"
        });
        return;
      }
      toast["a" /* default */].loading({
        message: "领取中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0
      });
      var adData = {
        type: "LANTIAN_JIAXIAO",
        name: "南职蓝天驾校用户信息",
        reservedOne: this.mobile
      };
      api.setAdRecord(adData).then(function () {
        toast["a" /* default */].clear();
        Object(toast["a" /* default */])({
          message: "领取成功",
          icon: "medal-o"
        });
      }).catch(function (e) {
        toast["a" /* default */].clear();
        Object(toast["a" /* default */])({
          message: "领取失败",
          icon: "smile-o"
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34976a1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/collectCustomerInfo/studentDriver/blueSkySt.vue
var blueSkySt_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blue-sky-st-bg" }, [
    _c("div", { staticClass: "blue-sky-st" }, [
      _c("img", {
        staticClass: "coupons-image",
        attrs: { src: __webpack_require__("lFoe") }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bind-mobile" },
        [
          _c("van-field", {
            staticClass: "field",
            attrs: { label: "", placeholder: "绑定手机号码领取" },
            model: {
              value: _vm.mobile,
              callback: function($$v) {
                _vm.mobile = $$v
              },
              expression: "mobile"
            }
          }),
          _vm._v(" "),
          _c(
            "van-button",
            {
              staticClass: "button",
              attrs: { icon: "star-o", color: "#ea0835", type: "primary" },
              on: { click: _vm.bindBobile }
            },
            [_vm._v("立即领取")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("img", {
        staticClass: "coupons-image",
        attrs: { src: __webpack_require__("6NVF") }
      })
    ])
  ])
}
var blueSkySt_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "use-mark" }, [
      _c("div", { staticClass: "use-mark-item" }, [
        _c("span", { staticClass: "use-mark-item-title" }, [
          _vm._v("优惠券有效期")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "use-mark-item-detail" }, [
          _vm._v("有效期至2020年08月01日。")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "use-mark-item" }, [
        _c("span", { staticClass: "use-mark-item-title" }, [
          _vm._v("使用条件")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "use-mark-item-detail" }, [
          _vm._v("领取优惠券后指定教练员和班型使用。")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "use-mark-item" }, [
        _c("span", { staticClass: "use-mark-item-title" }, [
          _vm._v("使用限制")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "use-mark-item-detail" }, [
          _vm._v(
            "该优惠券只适用于部分教练员，领取成功后指定教练员会及时联系您。"
          )
        ])
      ])
    ])
  }
]
blueSkySt_render._withStripped = true
var blueSkySt_esExports = { render: blueSkySt_render, staticRenderFns: blueSkySt_staticRenderFns }
/* harmony default export */ var collectCustomerInfo_studentDriver_blueSkySt = (blueSkySt_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34976a1c", blueSkySt_esExports)
  }
}
// CONCATENATED MODULE: ./src/page/collectCustomerInfo/studentDriver/blueSkySt.vue
var blueSkySt_disposed = false
function blueSkySt_injectStyle (ssrContext) {
  if (blueSkySt_disposed) return
  __webpack_require__("162F")
}
var blueSkySt_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var blueSkySt___vue_template_functional__ = false
/* styles */
var blueSkySt___vue_styles__ = blueSkySt_injectStyle
/* scopeId */
var blueSkySt___vue_scopeId__ = "data-v-34976a1c"
/* moduleIdentifier (server only) */
var blueSkySt___vue_module_identifier__ = null
var blueSkySt_Component = blueSkySt_normalizeComponent(
  studentDriver_blueSkySt,
  collectCustomerInfo_studentDriver_blueSkySt,
  blueSkySt___vue_template_functional__,
  blueSkySt___vue_styles__,
  blueSkySt___vue_scopeId__,
  blueSkySt___vue_module_identifier__
)
blueSkySt_Component.options.__file = "src/page/collectCustomerInfo/studentDriver/blueSkySt.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-34976a1c", blueSkySt_Component.options)
  } else {
    hotAPI.reload("data-v-34976a1c", blueSkySt_Component.options)
  }
  module.hot.dispose(function (data) {
    blueSkySt_disposed = true
  })
})()}

/* harmony default export */ var page_collectCustomerInfo_studentDriver_blueSkySt = (blueSkySt_Component.exports);

// CONCATENATED MODULE: ./src/router/router.js















vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: "",
  component: src_page_HelloWorld
}, //没有任何路由时候,显示这个路由对应的组件
{
  path: "/",
  name: "welcome",
  component: src_page_HelloWorld
}, {
  path: "/cms",
  name: "cms",
  component: src_page_CMS
}, {
  path: "/busSupport",
  name: "busSupport",
  component: src_page_BusSupport
}, {
  path: "/miniQrcode",
  name: "miniQrcode",
  component: miniQrcode
}, {
  path: "/tips",
  name: "tips",
  component: miniUrl_tips
}, {
  path: "/alipay",
  name: "alipay",
  component: src_page_miniUrl_alipay
}, {
  path: "/wechat",
  name: "wechat",
  component: miniUrl_wechat
}, {
  path: "/browser",
  name: "browser",
  component: src_page_miniUrl_browser
}, {
  path: "/window",
  name: "window",
  component: src_page_miniUrl_window
}, {
  path: "/ncljl",
  name: "ncljlPromote",
  component: src_page_AlipayRedEnvelope_ncljlPromote
}, {
  path: "/blueskySt",
  name: "BlueSkySt",
  component: page_collectCustomerInfo_studentDriver_blueSkySt
}, {
  path: "/*",
  redirect: "/" // 没有匹配到任何路由时,显示这个路由对应的组件
}];

var router = new vue_router_esm["a" /* default */]({
  routes: routes
});

/* harmony default export */ var router_router = (router);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
    name: 'App'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
    name: 'App'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [_c("router-view")], 1)
}
var App_staticRenderFns = []
App_render._withStripped = true
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", App_esExports)
  }
}
// CONCATENATED MODULE: ./src/App.vue
var App_disposed = false
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)
App_Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", App_Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", App_Component.options)
  }
  module.hot.dispose(function (data) {
    App_disposed = true
  })
})()}

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js




vue_esm["a" /* default */].config.productionTip = false;

new vue_esm["a" /* default */]({
  el: '#app',
  router: router_router,
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "NSaQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/04_03.ffd03c3.png";

/***/ }),

/***/ "NcXw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/01_03.8af58b6.png";

/***/ }),

/***/ "O96h":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nbody[data-v-283f02c6]{\n  margin: 0px;\n  padding: 0px;\n}\n.content[data-v-283f02c6] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n}\n.top[data-v-283f02c6]{\n  -webkit-box-flex: 8;\n  -webkit-flex: 8;\n          flex: 8;\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n  background-color: #00a8ec;\n}\n.searchMark[data-v-283f02c6] {\n  width: 80%;\n  margin-top: 10%;\n}\n.search[data-v-283f02c6] {\n  margin-top: 10%;\n  width: 84%;\n}\n.title[data-v-283f02c6] {\n  margin-top: 5%;\n  width: 90%;\n}\n.appUi[data-v-283f02c6] {\n  margin-top: 10%;\n  width: 70%;\n}\n.bottom[data-v-283f02c6] {\n  -webkit-box-flex: 2;\n  -webkit-flex: 2;\n          flex: 2;\n  width: 100%;\n  height: 20%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  padding: 40px 0;\n}\n.logoIcon[data-v-283f02c6] {\n  width: 60%;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "QHGZ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4Yh7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2e0424f8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ddcc4950\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./alipay.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ddcc4950\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./alipay.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "QXZ8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("V4zn");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("ecdd56cc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6acb2e34\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./wechat.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6acb2e34\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./wechat.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "RF85":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wl_hmzx.fd5157e.png";

/***/ }),

/***/ "SLZn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/04_11.5ba554e.png";

/***/ }),

/***/ "T2s0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V4zn":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.wechat[data-v-6acb2e34] {\n  width: 100vw;\n  height: 100vh;\n  background-color: #ffffff;\n}\n.top[data-v-6acb2e34]{\n  -webkit-box-flex: 8;\n  -webkit-flex: 8;\n          flex: 8;\n  width: 100vw;\n  height: calc(100vw * 537 / 750);\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n          align-items: flex-start;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n          justify-content: flex-start;\n  background: url(" + escape(__webpack_require__("t2DH")) + ") center center no-repeat;\n  background-size: contain;\n}\n.top p[data-v-6acb2e34] {\n  padding-left: 32px;\n  color: #ffffff;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.top p span[data-v-6acb2e34] {\n  color: #efc161;\n}\n.top .title[data-v-6acb2e34] {\n  font-size: 28px;\n  font-weight: bold;\n  margin-top: 40px;\n  margin-bottom: 20px;\n}\n.top .mark[data-v-6acb2e34] {\n  font-size: 20px;\n  font-weight: bold;\n  margin-top: 12px;\n}\n.image-content[data-v-6acb2e34] {\n  padding: 0 32px;\n}\n.image-content p[data-v-6acb2e34] {\n  font-size: 16px;\n  font-weight: bold;\n  text-align: center;\n  margin: 0;\n}\n.image-content .tips[data-v-6acb2e34] {\n  /* color: #efc161; */\n  font-size: 18px;\n  font-weight: bold;\n}\n.image-content .methods-title[data-v-6acb2e34] {\n  text-align: left;\n  font-size: 20px;\n}\n.methods-title-all[data-v-6acb2e34] {\n  text-align: center;\n  font-size: 24px;\n  margin: 0 0 20px;\n  font-weight: bold;\n}\n.methods-b[data-v-6acb2e34] {\n  margin-top: 32px;\n}\n.methods-b img[data-v-6acb2e34] {\n  margin-top: 16px;\n}\n.company-info[data-v-6acb2e34] {\n  text-align: center;\n  margin: 100px 0 32px;\n  color: #666;\n}\n", ""]);

// exports


/***/ }),

/***/ "VFIX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "WH3E":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("O96h");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("664bafae", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-283f02c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tips.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-283f02c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tips.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "WpgC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZZbq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.window[data-v-76ff09fe] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  background-color: #108ee9;\n  min-height: 100vh;\n  padding-bottom: 200px;\n  max-width: 477px;\n}\n.top-image[data-v-76ff09fe] {\n  margin: 64px 64px 0;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "bELE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4PJr");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0e51f124", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29fa7a92\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HelloWorld.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29fa7a92\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HelloWorld.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "cUcc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Jnhj");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7653340a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c3b0686\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BusSupport.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c3b0686\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BusSupport.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "eh36":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hW8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i/qG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wl_yjgk.dc5c874.png";

/***/ }),

/***/ "ijc4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/applet-qr-code.26c5d77.jpg";

/***/ }),

/***/ "iwAQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.scan-guide[data-v-69a2f5ec] {\n  min-height: 100vh;\n  width: 100%;\n  max-width: 520px;\n  margin: 0 auto;\n  padding: 16px 18px 18px;\n  box-sizing: border-box;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  background:\n    -webkit-radial-gradient(120% 90% at 88% -10%, rgba(7, 193, 96, 0.30), transparent 55%),\n    -webkit-radial-gradient(90% 70% at -12% 108%, rgba(56, 142, 215, 0.26), transparent 60%),\n    -webkit-linear-gradient(282deg, #082739 0%, #0a3d38 55%, #0d4a3c 100%);\n  background:\n    radial-gradient(120% 90% at 88% -10%, rgba(7, 193, 96, 0.30), transparent 55%),\n    radial-gradient(90% 70% at -12% 108%, rgba(56, 142, 215, 0.26), transparent 60%),\n    linear-gradient(168deg, #082739 0%, #0a3d38 55%, #0d4a3c 100%);\n}\n\n/* 顶部品牌 */\n.brand[data-v-69a2f5ec] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  margin: 2px auto 16px;\n  padding: 8px 18px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.10);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n.brand-ic[data-v-69a2f5ec] {\n  width: 28px;\n  height: 28px;\n  margin-right: 10px;\n  border-radius: 9px;\n  background: -webkit-linear-gradient(315deg, #07c160, #069b4e);\n  background: linear-gradient(135deg, #07c160, #069b4e);\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-justify-content: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n  box-shadow: 0 3px 10px -2px rgba(7, 193, 96, 0.7);\n}\n.brand-ic svg[data-v-69a2f5ec] {\n  width: 17px;\n  height: 17px;\n}\n\n/* 白色主卡片 */\n.card[data-v-69a2f5ec] {\n  width: 100%;\n  background: #fff;\n  border-radius: 26px;\n  padding: 30px 22px 24px;\n  text-align: center;\n  box-shadow: 0 28px 64px -20px rgba(0, 22, 10, 0.60), 0 4px 18px rgba(0, 0, 0, 0.16);\n}\n\n/* 扫描取景框 */\n.frame[data-v-69a2f5ec] {\n  position: relative;\n  width: 62vw;\n  height: 62vw;\n  max-width: 230px;\n  max-height: 230px;\n  margin: 4px auto 0;\n}\n.frame[data-v-69a2f5ec]::after {\n  content: \"\";\n  position: absolute;\n  top: -14px;\n  right: -14px;\n  bottom: -14px;\n  left: -14px;\n  border-radius: 34px;\n  border: 2.5px solid rgba(7, 193, 96, 0.4);\n  -webkit-animation: sg-pulse-data-v-69a2f5ec 2.4s ease-out infinite;\n          animation: sg-pulse-data-v-69a2f5ec 2.4s ease-out infinite;\n}\n.frame .c[data-v-69a2f5ec] {\n  position: absolute;\n  width: 38px;\n  height: 38px;\n  border: 0 solid #07c160;\n}\n.c1[data-v-69a2f5ec] { left: 0;   top: 0;    border-top-width: 5px;    border-left-width: 5px;    border-top-left-radius: 18px;\n}\n.c2[data-v-69a2f5ec] { right: 0;  top: 0;    border-top-width: 5px;    border-right-width: 5px;   border-top-right-radius: 18px;\n}\n.c3[data-v-69a2f5ec] { left: 0;   bottom: 0; border-bottom-width: 5px; border-left-width: 5px;    border-bottom-left-radius: 18px;\n}\n.c4[data-v-69a2f5ec] { right: 0;  bottom: 0; border-bottom-width: 5px; border-right-width: 5px;   border-bottom-right-radius: 18px;\n}\n.frame-inner[data-v-69a2f5ec] {\n  position: absolute;\n  top: 11%;\n  right: 11%;\n  bottom: 11%;\n  left: 11%;\n  background: #f1fbf6;\n  border: 1.5px solid #d8f2e4;\n  border-radius: 24px;\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-justify-content: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n}\n.frame-inner svg[data-v-69a2f5ec] {\n  width: 60%;\n  -webkit-filter: drop-shadow(0 6px 14px rgba(7, 193, 96, 0.35));\n          filter: drop-shadow(0 6px 14px rgba(7, 193, 96, 0.35));\n}\n.scanline[data-v-69a2f5ec] {\n  position: absolute;\n  left: 9%;\n  right: 9%;\n  top: 14%;\n  height: 3.5px;\n  border-radius: 99px;\n  background: -webkit-linear-gradient(left, transparent, #07c160 22%, #07c160 78%, transparent);\n  background: linear-gradient(90deg, transparent, #07c160 22%, #07c160 78%, transparent);\n  box-shadow: 0 0 20px 5px rgba(7, 193, 96, 0.55);\n  -webkit-animation: sg-scan-data-v-69a2f5ec 2.2s ease-in-out infinite alternate;\n          animation: sg-scan-data-v-69a2f5ec 2.2s ease-in-out infinite alternate;\n}\n.frame-cap[data-v-69a2f5ec] {\n  margin-top: 14px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #06ad56;\n  letter-spacing: 4px;\n}\n\n/* 当前软件检测徽章 */\n.app-badge[data-v-69a2f5ec] {\n  display: inline-block;\n  margin-top: 16px;\n  padding: 8px 16px;\n  border-radius: 999px;\n  background: -webkit-linear-gradient(315deg, #fff3e2, #ffe9e4);\n  background: linear-gradient(135deg, #fff3e2, #ffe9e4);\n  border: 1px solid #ffd6bd;\n  color: #c2410c;\n  font-size: 13.5px;\n  font-weight: 800;\n}\n.app-badge .dot[data-v-69a2f5ec] {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #f76707;\n  margin-right: 7px;\n  -webkit-animation: sg-blink-data-v-69a2f5ec 1.1s ease-in-out infinite;\n          animation: sg-blink-data-v-69a2f5ec 1.1s ease-in-out infinite;\n}\nh1[data-v-69a2f5ec] {\n  margin: 16px 0 10px;\n  font-size: 7.4vw;\n  line-height: 1.3;\n  font-weight: 900;\n  letter-spacing: 1px;\n  color: #101828;\n}\nh1 em[data-v-69a2f5ec] {\n  font-style: normal;\n  color: #06ad56;\n  background: -webkit-linear-gradient(transparent 64%, #b7f0d2 64%);\n  background: linear-gradient(transparent 64%, #b7f0d2 64%);\n  padding: 0 3px;\n  border-radius: 4px;\n}\n.sub[data-v-69a2f5ec] {\n  color: #475467;\n  font-size: 15px;\n  line-height: 1.75;\n  margin-bottom: 18px;\n}\n.sub strong[data-v-69a2f5ec] {\n  color: #e0500f;\n}\n\n/* 三步引导 */\n.steps[data-v-69a2f5ec] {\n  list-style: none;\n  padding: 18px 16px;\n  margin: 0;\n  text-align: left;\n  background: #f7fbf9;\n  border: 1px solid #e5f3ec;\n  border-radius: 18px;\n}\n.steps li[data-v-69a2f5ec] {\n  display: -webkit-flex;\n  display: -webkit-box;\n  display: flex;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n          align-items: center;\n  font-size: 15.5px;\n  font-weight: 600;\n  color: #101828;\n}\n.steps li + li[data-v-69a2f5ec] {\n  margin-top: 16px;\n}\n.steps .num[data-v-69a2f5ec] {\n  -webkit-flex: 0 0 28px;\n  -webkit-box-flex: 0;\n          flex: 0 0 28px;\n  width: 28px;\n  height: 28px;\n  margin-right: 13px;\n  border-radius: 50%;\n  background: -webkit-linear-gradient(315deg, #07c160, #06ad56);\n  background: linear-gradient(135deg, #07c160, #06ad56);\n  color: #fff;\n  font-weight: 800;\n  font-size: 15px;\n  text-align: center;\n  line-height: 28px;\n  box-shadow: 0 5px 12px -3px rgba(7, 193, 96, 0.55);\n}\n.steps b[data-v-69a2f5ec] {\n  color: #06ad56;\n}\n.plus[data-v-69a2f5ec] {\n  display: inline-block;\n  width: 23px;\n  height: 23px;\n  margin: 0 3px;\n  border-radius: 7px;\n  background: #07c160;\n  color: #fff;\n  font-weight: 800;\n  text-align: center;\n  line-height: 23px;\n  vertical-align: -5px;\n  box-shadow: 0 3px 8px -2px rgba(7, 193, 96, 0.6);\n}\n.banner-tip[data-v-69a2f5ec] {\n  margin-top: 18px;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #0b7a4b;\n  background: #eefbf4;\n  border: 1px dashed #9fdebd;\n  border-radius: 12px;\n  padding: 10px 12px;\n}\n\n/* 公交行驶动画 */\n.road[data-v-69a2f5ec] {\n  position: relative;\n  width: 100%;\n  height: 58px;\n  margin-top: 16px;\n  overflow: hidden;\n}\n.road[data-v-69a2f5ec]::before {\n  content: \"\";\n  position: absolute;\n  left: -4%;\n  right: -4%;\n  top: 40px;\n  border-top: 2.5px dashed rgba(255, 255, 255, 0.32);\n}\n.bus[data-v-69a2f5ec] {\n  position: absolute;\n  top: 4px;\n  left: -72px;\n  width: 58px;\n  -webkit-animation: sg-drive-data-v-69a2f5ec 9s linear infinite;\n          animation: sg-drive-data-v-69a2f5ec 9s linear infinite;\n}\n.foot[data-v-69a2f5ec] {\n  margin-top: 8px;\n  padding-bottom: 2px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 12.5px;\n  letter-spacing: 0.5px;\n}\n@-webkit-keyframes sg-scan-data-v-69a2f5ec {\nfrom { top: 14%;\n}\nto   { top: 84%;\n}\n}\n@keyframes sg-scan-data-v-69a2f5ec {\nfrom { top: 14%;\n}\nto   { top: 84%;\n}\n}\n@-webkit-keyframes sg-pulse-data-v-69a2f5ec {\n0%   { -webkit-transform: scale(0.94); transform: scale(0.94); opacity: 0.9;\n}\n70%  { -webkit-transform: scale(1.08); transform: scale(1.08); opacity: 0;\n}\n100% { -webkit-transform: scale(1.08); transform: scale(1.08); opacity: 0;\n}\n}\n@keyframes sg-pulse-data-v-69a2f5ec {\n0%   { -webkit-transform: scale(0.94); transform: scale(0.94); opacity: 0.9;\n}\n70%  { -webkit-transform: scale(1.08); transform: scale(1.08); opacity: 0;\n}\n100% { -webkit-transform: scale(1.08); transform: scale(1.08); opacity: 0;\n}\n}\n@-webkit-keyframes sg-blink-data-v-69a2f5ec {\n0%, 100% { opacity: 1;\n}\n50%      { opacity: 0.25;\n}\n}\n@keyframes sg-blink-data-v-69a2f5ec {\n0%, 100% { opacity: 1;\n}\n50%      { opacity: 0.25;\n}\n}\n@-webkit-keyframes sg-drive-data-v-69a2f5ec {\nfrom { left: -72px;\n}\nto   { left: calc(100% + 12px);\n}\n}\n@keyframes sg-drive-data-v-69a2f5ec {\nfrom { left: -72px;\n}\nto   { left: calc(100% + 12px);\n}\n}\n@media (min-width: 480px) {\nh1[data-v-69a2f5ec] { font-size: 32px;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "iwBE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wl_yztc.f012918.png";

/***/ }),

/***/ "kZU+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.ncojl-promote[data-v-315574b6] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  background-color: #108ee9;\n  min-height: 100vh;\n  padding-bottom: 200px;\n  max-width: 477px;\n}\n.ncojl-promote .top-image[data-v-315574b6] {\n  margin: 64px 64px 0;\n}\n", ""]);

// exports


/***/ }),

/***/ "l7ic":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "lFoe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coupons.987af57.png";

/***/ }),

/***/ "n1YV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/red-envelope-top.7e78d11.png";

/***/ }),

/***/ "nsZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ntTm":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nbody[data-v-25e4bbfc] {\n  line-height: 1.6;\n  font-family: -apple-system-font, BlinkMacSystemFont, \"Helvetica Neue\",\n    \"PingFang SC\", \"Hiragino Sans GB\", \"Microsoft YaHei UI\", \"Microsoft YaHei\",\n    Arial, sans-serif;\n  font-size: 16px;\n}\ndiv[data-v-25e4bbfc] {\n  margin: 0;\n  padding: 0;\n  display: block;\n}\nh1[data-v-25e4bbfc],\nh2[data-v-25e4bbfc],\nh3[data-v-25e4bbfc],\nh4[data-v-25e4bbfc],\nh5[data-v-25e4bbfc],\nh6[data-v-25e4bbfc] {\n  font-weight: 400;\n  font-size: 16px;\n  margin: 0;\n  padding: 0;\n}\n.article[data-v-25e4bbfc] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  background-color: #fafafa;\n}\n.article-content[data-v-25e4bbfc] {\n  max-width: 677px;\n  width: 100%;\n  min-height: 100vh;\n  background-color: white;\n}\n.rich_media_area[data-v-25e4bbfc] {\n  min-height: 100vh;\n  width: 100%;\n}\n.rich_media_area_primary[data-v-25e4bbfc] {\n  padding: 20px 16px 80px;\n  width: 100%;\n  box-sizing: border-box;\n}\n.rich_media_area_primary .rich_media_title[data-v-25e4bbfc] {\n  font-size: 22px;\n  line-height: 1.4;\n  margin-bottom: 14px;\n}\n.rich_media_area_primary .rich_media_meta_list[data-v-25e4bbfc] {\n  margin-bottom: 22px;\n  line-height: 20px;\n  font-size: 15px;\n  word-wrap: break-word;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n}\n.rich_media_area_primary .rich_media_meta_list .rich_media_meta[data-v-25e4bbfc] {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 10px 10px 0;\n  font-size: 15px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rich_media_area_primary .rich_media_meta_list .rich_media_meta_nickname[data-v-25e4bbfc] {\n  color: #7d90a9;\n  cursor: pointer;\n  text-decoration: none;\n}\n.rich_media_area_primary .rich_media_meta_list em[data-v-25e4bbfc] {\n  font-style: normal;\n}\n.rich_media_area_primary .rich_media_content[data-v-25e4bbfc] {\n  position: relative;\n  overflow: hidden;\n  color: #333;\n  font-size: 17px;\n  word-wrap: break-word;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n  text-align: justify;\n  position: relative;\n  z-index: 0;\n}\n.none-content[data-v-25e4bbfc] {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  margin-top: 100px;\n}\n.none-content .deleted[data-v-25e4bbfc] {\n  width: 30%;\n  height: 30%;\n}\n.none-content .mark[data-v-25e4bbfc] {\n  font-size: 16px;\n  margin-top: 16px;\n}\n.bottom[data-v-25e4bbfc] {\n  width: 100%;\n  max-width: 677px;\n  position: fixed;\n  /* margin-left: -10px; */\n  bottom: 0px;\n  height: 49px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n}\n.bottom .tel[data-v-25e4bbfc] {\n  width: 100%;\n  line-height: 49px;\n  background-color: #f5f5f5;\n  text-align: center;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-flex: 7;\n  -webkit-flex: 7;\n          flex: 7;\n}\n.bottom .tel img[data-v-25e4bbfc] {\n  height: 50%;\n  width: 50%;\n  margin-top: 30%;\n}\n.bottom .btn[data-v-25e4bbfc] {\n  -webkit-box-flex: 3;\n  -webkit-flex: 3;\n          flex: 3;\n  background-color: #40a9ff;\n  line-height: 49px;\n  color: white;\n  text-align: center;\n}\n", ""]);

// exports


/***/ }),

/***/ "okab":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ZZbq");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3e15ce37", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-76ff09fe\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./window.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-76ff09fe\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./window.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "px3J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qpP9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t2DH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wechat-bg.c2c7614.png";

/***/ }),

/***/ "xDUG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coupons-bg.446bcff.png";

/***/ }),

/***/ "xg5c":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.blue-sky-st-bg[data-v-34976a1c] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  background-color: #fafafa;\n  min-height: 100vh;\n}\n.blue-sky-st-bg .blue-sky-st[data-v-34976a1c] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n  background: url(" + escape(__webpack_require__("xDUG")) + ") no-repeat;\n  background-size: 100% 100%;\n  min-height: 100vh;\n  max-width: 477px;\n  width: 100%;\n}\n.blue-sky-st-bg .blue-sky-st .coupons-image[data-v-34976a1c] {\n  width: 80%;\n  margin-top: 64px;\n}\n.blue-sky-st-bg .blue-sky-st .use-mark[data-v-34976a1c] {\n  margin-top: 16px;\n  width: 80%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n}\n.blue-sky-st-bg .blue-sky-st .use-mark .use-mark-item[data-v-34976a1c] {\n  width: 80%;\n  margin-top: 16px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n}\n.blue-sky-st-bg .blue-sky-st .use-mark span[data-v-34976a1c] {\n  color: white;\n}\n.blue-sky-st-bg .blue-sky-st .use-mark .use-mark-item .use-mark-item-title[data-v-34976a1c] {\n  font-weight: bold;\n  font-size: 16px;\n}\n.blue-sky-st-bg .blue-sky-st .use-mark .use-mark-item .use-mark-item-detail[data-v-34976a1c] {\n  margin-top: 4px;\n  font-size: 15px;\n}\n.blue-sky-st-bg .blue-sky-st .bind-mobile[data-v-34976a1c] {\n  margin-top: 16px;\n  width: 80%;\n  height: 50px;\n  background-color: #ffffff;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n          align-items: center;\n}\n.blue-sky-st-bg .blue-sky-st .bind-mobile .button[data-v-34976a1c] {\n  width: 200px;\n  margin-right: 2px;\n}\n", ""]);

// exports


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.675133b596580902d952.js